import _regeneratorRuntime from 'babel-runtime/regenerator';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { GoogleMap, TrafficLayer, MarkerClusterer, Marker, Circle, InfoWindow, DirectionsService, DirectionsRenderer, Polygon } from '@react-google-maps/api';
import check0 from '../layerInfo/layers-devices/img/check0.png'; // desactivado
import check1 from '../layerInfo/layers-devices/img/check1.png'; // activado
import check2 from '../layerInfo/layers-devices/img/check2.png'; // pendiente de desactivar
import check3 from '../layerInfo/layers-devices/img/check3.png'; // pendiente de activar

import $ from "jquery";

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import DirectionsOutlinedIcon from '@material-ui/icons/DirectionsOutlined';
import Tooltip from '@material-ui/core/Tooltip';

import MarkerV2 from '../markers/markersVehicle2';
import PopUpDeviceInfo from '../vehiclePopUpInfo/PopUpDeviceInfo';
import MarkerService from '../markers/markersService/markersService';
import MarkersPois from '../markers/markersPois/MarkersPois';

import IconOptionsMap from '../IconOptionMap';
import Select from 'react-select';
import { OptionsProfiles } from './dataSelect';
import BottomData from '../layers/BottomData';

// import '../layerInfo/layer.css';
// import '../layerInfo/layer-responsive.css';
import './App.css';
// import './newIcons.css';
import { withTranslation } from 'react-i18next';
import markerIcon from '../../img/placeholder.png';
// import './bootstrap.min.css';
import Geocode from "react-geocode";
import { Grid } from '@material-ui/core';
Geocode.setApiKey("AIzaSyDseP7HF_56aFB57irUQeEi5438tD4PSlk");

var jsonGroups = "";
var jsonInfo = "";
var jsonIOInfo = "";
var jsonTasksOrders = "";
var jsonRegions = "";
var realTimeDestinations = "";
var jsonTasksOrdersWithOutDestinations = "";
var jsonPois = "";
var jsonPoisInfo = "";

var Map = function (_Component) {
    _inherits(Map, _Component);

    function Map(props) {
        var _this2 = this;

        _classCallCheck(this, Map);

        var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));

        _this.goToPageErr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this.props.propsRouter.location.userHasAuthenticated(false);
                            // console.log("entra");
                            _this.props.propsRouter.history.push({
                                pathname: '/ExpireKeyErr/',
                                state: {
                                    userDataInfo: ''
                                }
                            });

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        _this.adaptState = function (values) {
            return values.map(function (value) {
                switch (value) {
                    case 0:
                        return { src: check0, state: "desactivado" };
                    case 1:
                        return { src: check1, state: "activado" };
                    case 2:
                        return { src: check2, state: "pendiente de activar" };
                    case 3:
                        return { src: check3, state: "pendiente de desactivar" };
                    default:
                        return { src: check0, state: "desactivado" };
                }
            });
        };

        _this.getPoisData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            var responsePois, i, element;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return fetch(_this.state.urlApi + "PoisTags", {
                                headers: {
                                    'accessToken': _this.props.accessToken
                                }
                            });

                        case 2:
                            responsePois = _context2.sent;

                            if (!responsePois.ok) {
                                _context2.next = 11;
                                break;
                            }

                            _context2.next = 6;
                            return responsePois.json();

                        case 6:
                            jsonPois = _context2.sent;

                            for (i = 0; i < jsonPois.length; i++) {
                                element = Object.assign({}, jsonPois[i], { isChecked: false });

                                jsonPois[i] = element;
                            }

                            localStorage.setItem("jsonGroupsPoisWithOutPois", JSON.stringify(jsonPois));

                            _context2.next = 12;
                            break;

                        case 11:
                            alert("HTTP-Error: " + responsePois.status);

                        case 12:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));
        _this.getPoisInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
            var jsonPoisGroups, spinnerLoading, responsePoisInfo, i, j, infoPoi;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            jsonPoisGroups = "";
                            spinnerLoading = document.getElementById("spinnerLoading");

                            spinnerLoading.style.display = "inline-block";
                            _context3.next = 5;
                            return fetch(_this.state.urlApi + "PoisInfo", {
                                headers: {
                                    'accessToken': _this.props.accessToken
                                }
                            });

                        case 5:
                            responsePoisInfo = _context3.sent;

                            if (!responsePoisInfo.ok) {
                                _context3.next = 13;
                                break;
                            }

                            _context3.next = 9;
                            return responsePoisInfo.json();

                        case 9:
                            jsonPoisInfo = _context3.sent;


                            if (document.getElementById("layer3-btn").disabled === true) {

                                document.getElementById("layer3-btn").disabled = false;
                            }
                            // localStorage.setItem("jsonGroupsService", JSON.stringify(jsonPois));
                            _context3.next = 14;
                            break;

                        case 13:
                            alert("HTTP-Error: " + responsePoisInfo.status);

                        case 14:

                            jsonPoisGroups = localStorage.getItem("jsonGroupsPoisWithOutPois");
                            jsonPoisGroups = JSON.parse(jsonPoisGroups);

                            if (jsonPoisInfo !== undefined) {
                                if (jsonPoisInfo !== null) {
                                    for (i = 0; i < jsonPoisGroups.length; i++) {
                                        for (j = 0; j < jsonPoisInfo.length; j++) {
                                            if (jsonPoisGroups[i].poisInfo !== null) {
                                                // console.log(jsonPoisGroups[i])
                                                if (jsonPoisInfo[j].idTipo === jsonPoisGroups[i].idTipo) {
                                                    infoPoi = Object.assign({}, jsonPoisInfo[j], { isChecked: false });

                                                    jsonPoisGroups[i].poisInfo.push(infoPoi);
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            localStorage.setItem("jsonGroupsPois", JSON.stringify(jsonPoisGroups));
                            _this.setState({
                                center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                                options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom }),
                                groupsPois: jsonPoisGroups,
                                originalGroupPois: jsonPoisGroups,
                                layerPois: true,
                                jsonPoisInfo: jsonPoisInfo
                            }, function () {

                                spinnerLoading.style.display = "none";

                                // if (jsonPoisInfo.length > 0) {
                                //     document.getElementById("layer3-btn").disabled = false;
                                // }

                            });
                            return _context3.abrupt('return', jsonPoisInfo);

                        case 20:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this2);
        }));

        _this.saveJsonIOInfo = function (dataToSave) {
            var dbName = '4GFlota-DDBB-Servicios';
            var storeName = 'jsonIOInfoTable';

            // Abrir o crear la base de datos
            var request = indexedDB.open(dbName, 1);

            request.onupgradeneeded = function (event) {
                var db = event.target.result;

                // Crear un almacén de objetos si aún no existe
                if (!db.objectStoreNames.contains(storeName)) {
                    db.createObjectStore(storeName);
                }
            };

            request.onsuccess = function (event) {
                var db = event.target.result;

                // Realizar operaciones en la base de datos
                // Por ejemplo, obtener datos

                // Primero, abrir una transacción de lectura/escritura
                var transaction = db.transaction([storeName], 'readwrite');
                var objectStore = transaction.objectStore(storeName);

                // Luego, eliminar todos los datos existentes en el almacén
                var clearRequest = objectStore.clear();

                clearRequest.onsuccess = function () {
                    // Después de borrar, guardar nuevos datos
                    var putRequest = objectStore.put(dataToSave, 'jsonIOInfo');

                    putRequest.onsuccess = function () {
                        //console.log('Datos guardados exitosamente en IndexedDB.');
                    };

                    putRequest.onerror = function (event) {
                        console.error('Error al intentar guardar en IndexedDB:', event.target.error);
                    };
                };

                clearRequest.onerror = function (event) {
                    console.error('Error al intentar borrar datos en IndexedDB:', event.target.error);
                };
            };

            request.onerror = function (event) {
                console.error('Error al abrir la base de datos:', event.target.error);
            };
        };

        _this.getDataFromIndexedDB = function () {
            var dbName = '4GFlota-DDBB-Servicios';
            var storeName = 'jsonIOInfoTable';

            return new Promise(function (resolve, reject) {
                var request = indexedDB.open(dbName, 1);

                request.onupgradeneeded = function (event) {
                    var db = event.target.result;

                    if (!db.objectStoreNames.contains(storeName)) {
                        db.createObjectStore(storeName);
                    }
                };

                request.onsuccess = function (event) {
                    var db = event.target.result;

                    var transaction = db.transaction([storeName], 'readonly');
                    var objectStore = transaction.objectStore(storeName);
                    var getRequest = objectStore.get('jsonIOInfo');

                    getRequest.onsuccess = function () {
                        var data = getRequest.result;
                        resolve(data);
                    };

                    getRequest.onerror = function (event) {
                        reject(event.target.error);
                    };
                };

                request.onerror = function (event) {
                    reject(event.target.error);
                };
            });
        };

        _this.transformDate = function (ticks) {

            var epochTicks = 621355968000000000;
            var ticksPerMillisecond = 10000; // whoa!
            var maxDateMilliseconds = 8640000000000000; // via http://ecma-international.org/ecma-262/5.1/#sec-15.9.1.1
            var congratulationsTimer;
            var anHourTicks = 36000000000;

            if (_this.props.localTime !== undefined) {
                anHourTicks = anHourTicks * _this.props.localTime;

                ticks = ticks + anHourTicks;
            }

            var months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

            if (isNaN(ticks)) {
                //      0001-01-01T00:00:00.000Z
                return "NANA-NA-NATNA:NA:BA.TMAN";
            }

            // convert the ticks into something javascript understands
            var ticksSinceEpoch = ticks - epochTicks;
            var millisecondsSinceEpoch = ticksSinceEpoch / ticksPerMillisecond;

            if (millisecondsSinceEpoch > maxDateMilliseconds) {
                //      +035210-09-17T07:18:31.111Z
                return "+WHOAWH-OA-ISTOO:FA:RA.WAYZ";
            }
            var date2 = new Date(millisecondsSinceEpoch);

            var date = new Date(millisecondsSinceEpoch);
            var day = date.getDate();
            if (day < 10) {
                day = "0" + day;
            }

            var month = date.getMonth();
            month = months[month];
            if (month < 10) {
                month = "0" + month;
            }

            var seconds = date.getSeconds();
            if (seconds < 10) {
                seconds = "0" + seconds;
            }

            var year = date.getFullYear();

            var hours = date.getUTCHours();

            var minutes = date.getUTCMinutes();

            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (hours < 10) {
                hours = "0" + hours;
            }

            // console.log(hours);
            var resultDate = day + "/" + month + "/" + year + " " + hours + ":" + minutes + ":" + seconds;
            return resultDate;
        };

        _this.transformDateAndCompare = function (ticks) {
            var bool = false;

            var hoy = new Date();
            var DIA_EN_MILISEGUNDOS = 24 * 60 * 60 * 1000;
            var ayer = new Date(hoy.getTime() - DIA_EN_MILISEGUNDOS);

            var epochTicks = 621355968000000000;
            var ticksPerMillisecond = 10000; // whoa!
            var maxDateMilliseconds = 8640000000000000; // via http://ecma-international.org/ecma-262/5.1/#sec-15.9.1.1
            var congratulationsTimer;
            var anHourTicks = 36000000000;

            if (_this.props.localTime !== undefined) {
                anHourTicks = anHourTicks * _this.props.localTime;
                ticks = ticks + anHourTicks;
            }

            if (isNaN(ticks)) {
                //      0001-01-01T00:00:00.000Z
                return "NANA-NA-NATNA:NA:BA.TMAN";
            }

            // convert the ticks into something javascript understands
            var ticksSinceEpoch = ticks - epochTicks;
            var millisecondsSinceEpoch = ticksSinceEpoch / ticksPerMillisecond;

            if (millisecondsSinceEpoch > maxDateMilliseconds) {
                //      +035210-09-17T07:18:31.111Z
                return "+WHOAWH-OA-ISTOO:FA:RA.WAYZ";
            }

            var newDate = new Date(millisecondsSinceEpoch);
            if (newDate <= ayer) {
                bool = true;
            } else {
                bool = false;
            }
            return bool;
        };

        _this.centerMap = function (updatelat, updatelng, zoom) {
            var position = {
                lat: updatelat,
                lng: updatelng
                //console.log(zoom);
            };if (_this.state.actualMap) {
                _this.state.actualMap.setZoom(zoom);
                _this.state.actualMap.panTo(position);
                if (/Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini|Nokia/i.test(navigator.userAgent)) {
                    $("#divResize").addClass("widget-container-close");
                    $("#btn-collapse").css("display", "block");
                }
            }
        };

        _this.centerMapWihtOutFollow = function (updatelat, updatelng, device, address) {

            if (/Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini|Nokia/i.test(navigator.userAgent)) {
                $("#divResize").addClass("widget-container-close");
                $("#btn-collapse").css("display", "block");
            }

            if (address !== undefined) {
                address = address;
            } else {
                address = _this.state.addressDevice;
            }
            _this.setState({
                center: { lat: updatelat, lng: updatelng },
                options: Object.assign({}, _this.state.options, { zoom: 18 }),
                isOpenDeviceContent: false,
                device: device,
                addressDevice: address,
                popUpInfoDevice: true,
                historicalInfoDevice: false
            });
        };

        _this.setLatLng = function (updatelat, updatelng, assetsIOTImei) {
            if (_this.state.isOpenDeviceContent && _this.state.centerDevice.assetsIOTImei === assetsIOTImei) {
                _this.setState({
                    isOpenDeviceContent: false,
                    centerDevice: { assetsIOTImei: assetsIOTImei },
                    center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                    options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom })
                });
                $("#divResize").addClass("widget-container-open");
            } else {
                _this.setState({
                    isOpenDeviceContent: true,
                    centerDevice: { assetsIOTImei: assetsIOTImei },
                    center: { lat: updatelat, lng: updatelng },
                    options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom })
                }, function () {

                    if (_this.state.isOpenDeviceContent) {
                        $("#divResize").addClass("widget-container-close");
                        $("#btn-collapse").css("display", "block");
                    }
                    _this.centerMap(updatelat, updatelng, 18);
                });
            }
        };

        _this.followCenterDevice = function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(jsonTempGroup, newArray, groupDevicesCopy, newSelection) {
                var newCenter, data;
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                newCenter = newArray.filter(function (device) {
                                    return device.assetsIOTImei === _this.state.centerDevice.assetsIOTImei;
                                });

                                if (!(newCenter.length <= 0)) {
                                    _context4.next = 13;
                                    break;
                                }

                                _context4.prev = 2;
                                _context4.next = 5;
                                return _this.getDataFromIndexedDB();

                            case 5:
                                data = _context4.sent;

                                jsonIOInfo = data;
                                // Hacer algo con los datos recuperados
                                _context4.next = 12;
                                break;

                            case 9:
                                _context4.prev = 9;
                                _context4.t0 = _context4['catch'](2);

                                console.error('Error al obtener datos de IndexedDB:', _context4.t0);

                            case 12:
                                //jsonIOInfo = localStorage.getItem("jsonIOInfo");
                                //jsonIOInfo = JSON.parse(jsonIOInfo);
                                newCenter = jsonIOInfo.filter(function (device) {
                                    return device.assetsIOTImei === _this.state.centerDevice.assetsIOTImei;
                                });

                            case 13:
                                // console.log(newCenter);
                                // let position = {
                                //     lat: newCenter[0].gpsInfo.latitude,
                                //     lng: newCenter[0].gpsInfo.longitude
                                // }

                                _this.setState({
                                    center: { lat: newCenter[0].gpsInfo.latitude, lng: newCenter[0].gpsInfo.longitude },
                                    options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom }),
                                    groupsDevices: groupDevicesCopy.length > 0 ? groupDevicesCopy : jsonTempGroup,
                                    markersV: newArray,
                                    value: newSelection,
                                    centerDevice: { assetsIOTImei: newCenter[0].assetsIOTImei }

                                });
                                // let input = document.getElementById("inputText");
                                // if (input.value != "") {

                                //     this.setState({
                                //         center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
                                //         options: { ...this.state.options, zoom: this.state.actualMap.zoom },
                                //         isOpenDeviceContent: false
                                //     })
                                // }
                                // else {

                                //     let newCenter = newArray.filter(device => device.assetsIOTImei === this.state.centerDevice.assetsIOTImei);

                                //     if (newCenter.length <= 0) {
                                //         jsonIOInfo = localStorage.getItem("jsonIOInfo");
                                //         jsonIOInfo = JSON.parse(jsonIOInfo);
                                //         newCenter = jsonIOInfo.filter(device => device.assetsIOTImei === this.state.centerDevice.assetsIOTImei);
                                //     }
                                //     // console.log(newCenter);
                                //     // let position = {
                                //     //     lat: newCenter[0].gpsInfo.latitude,
                                //     //     lng: newCenter[0].gpsInfo.longitude
                                //     // }

                                //     this.setState({
                                //         center: { lat: newCenter[0].gpsInfo.latitude, lng: newCenter[0].gpsInfo.longitude },
                                //         options: { ...this.state.options, zoom: this.state.actualMap.zoom },
                                //         groupsDevices: jsonTempGroup,
                                //         markersV: newArray,
                                //         centerDevice: { assetsIOTImei: newCenter[0].assetsIOTImei }

                                //     });
                                // }

                            case 14:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this2, [[2, 9]]);
            }));

            return function (_x, _x2, _x3, _x4) {
                return _ref4.apply(this, arguments);
            };
        }();

        _this.toggleUi = function () {
            var options = _this.state.options;
            _this.setState({
                center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                options: Object.assign({}, _this.state.options, { disableDefaultUI: !options.disableDefaultUI, zoom: _this.state.actualMap.zoom })
            });
        };

        _this.changeGroupMarkerVehicle = function () {
            _this.setState({
                isVehicleGrouped: !_this.state.isVehicleGrouped,
                center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom })
            });
        };

        _this.viewSatelliteMap = function () {
            _this.setState({
                center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                options: Object.assign({}, _this.state.options, { mapTypeId: 'satellite', zoom: _this.state.actualMap.zoom })
            });
        };

        _this.viewStandardMap = function () {
            _this.setState({
                center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                options: Object.assign({}, _this.state.options, { mapTypeId: 'roadmap', zoom: _this.state.actualMap.zoom })
            });
        };

        _this.mapMobile = function () {
            var options = _this.state.options;
            if (options.gestureHandling === 'cooperative') {
                _this.setState({
                    center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                    options: Object.assign({}, _this.state.options, { gestureHandling: 'greedy', zoom: _this.state.actualMap.zoom })
                });
            } else {
                _this.setState({
                    center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                    options: Object.assign({}, _this.state.options, { gestureHandling: 'cooperative', zoom: _this.state.actualMap.zoom })
                });
            }
        };

        _this.trafficLayerShow = function () {
            var trafficLayer = _this.state.isTrafficLayerShown;
            if (_this.state.isTrafficLayerShown === trafficLayer) {
                _this.setState({
                    center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                    isTrafficLayerShown: !trafficLayer

                });
            }
        };

        _this.chargeProfile = function (options, center, traffic, zoom) {
            // console.log("chargeProfile - Map")
            options.mapTypeControl = false;
            _this.setState({
                options: options,
                zoom: zoom,
                center: center,
                isTrafficLayerShown: traffic
            });
        };

        _this.onKeyUp = function (e) {
            var input = document.getElementById("inputText");
            var textToBeSearch = "";
            if (input !== null) textToBeSearch = input.value;

            textToBeSearch = textToBeSearch.toUpperCase();
            _this.appliedMarkersVFilter(_this.state.value, textToBeSearch);
        };

        _this.layerDeviceFunc = function () {
            //console.log("layerDeviceFunc")
            document.getElementById("layer1-btn").disabled = true;
            if (_this.state.layerDevice === false) {
                _this.getAssetsTags();
                _this.getAssetsInfo();
                _this.getAssetsIOT("1");
                _this.timerID = setInterval(function () {
                    _this.getAssetsIOT("1");
                }, 10000);
            } else {

                _this.setState({
                    layerDevice: !_this.state.layerDevice,
                    center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                    options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom }),
                    groupsDevices: [],
                    markersV: []
                }, function () {
                    return _this.clearIntervalDevices();
                });
            }
            if (document.getElementById("layer1-btn").disabled === true) {
                document.getElementById("layer1-btn").disabled = false;
            }

            // this.setState({
            //     layerDevice: !this.state.layerDevice,
            //     center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
            //     options: { ...this.state.options, zoom: this.state.actualMap.zoom },

            // }, () => {
            //     let test = this.state.layerDevice;


            //     if (test === false) {

            //         this.setState({
            //             groupsDevices: [],
            //             markersV: []
            //         }, () => this.clearIntervalDevices());
            //     } else {
            //         let spinnerLoading = document.getElementById("spinnerLoading");
            //         spinnerLoading.style.display = "inline-block";
            //         setTimeout(() => {
            //             let input = document.getElementById("inputText");
            //             let textToBeSearch = "";
            //             if (input !== null) {
            //                 textToBeSearch = input.value;
            //             }
            //             this.appliedMarkersVFilter(this.state.value, textToBeSearch, test);
            //         }, 0);

            //     }
            // });
        };

        _this.getTaskOrdersLayerFunc = function () {
            document.getElementById("layer2-btn").disabled = true;
            if (_this.state.layerDistribution === false) {
                _this.getTaskOrders();
                _this.getTasksOrdersWithoutDestinations();
            } else {
                _this.setState({
                    layerDistribution: !_this.state.layerDistribution,
                    center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                    options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom }),
                    groupsTasksServices: []
                }, function () {
                    return _this.clearIntervalDevices();
                });
                if (document.getElementById("layer2-btn").disabled === true) {
                    document.getElementById("layer2-btn").disabled = false;
                }
            }

            if (_this.state.layerDistribution === false) {
                var spinnerLoading = document.getElementById("spinnerLoading");
                spinnerLoading.style.display = "block";
            }

            var count = 0;
            _this.timerDestinations = setInterval(function () {
                if (count === 6) {
                    _this.getTaskOrders();

                    count = 0;
                } else {
                    _this.getStateDestinations();
                    count += 1;
                }
            }, 600000);
        };

        _this.layerDistributionFunc = function () {

            _this.setState({
                layerDistribution: !_this.state.layerDistribution,
                center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom })

            }, function () {
                var distributionLayerIsOpen = _this.state.layerDistribution;

                if (distributionLayerIsOpen === false) {

                    _this.setState({
                        groupsTasksServices: []
                    }, function () {
                        return _this.clearIntervalServices();
                    });
                } else {
                    var spinnerLoading = document.getElementById("spinnerLoading");
                    spinnerLoading.style.display = "inline-block";
                    setTimeout(function () {
                        var input = document.getElementById("inputTextDistribution");
                        var textToBeSearch = "";
                        if (input !== null) {
                            textToBeSearch = input.value;
                        }

                        _this.appliedMarkersDistributionFilter(_this.state.valueDistributionSelect, textToBeSearch, distributionLayerIsOpen);
                    }, 0);
                }
            });
        };

        _this.layerPoisFunc = function () {
            document.getElementById("layer3-btn").disabled = true;

            if (_this.state.layerPois) {

                _this.setState({
                    layerPois: !_this.state.layerPois,
                    center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                    options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom }),
                    groupsPois: [],
                    showCircleArea: false,
                    jsonPoisInfo: []

                });
                if (document.getElementById("layer3-btn").disabled === true) {
                    document.getElementById("layer3-btn").disabled = false;
                }
            } else {
                _this.getPoisData();
                _this.getPoisInfo();
            }
        };

        _this.layerRegionsFunc = function () {
            // getRegions
            document.getElementById("layer4-btn").disabled = true;
            if (_this.state.layerRegions) {

                _this.setState({
                    layerRegions: !_this.state.layerRegions,
                    center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                    options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom }),
                    groupRegions: []

                });
                if (document.getElementById("layer4-btn").disabled === true) {
                    document.getElementById("layer4-btn").disabled = false;
                }
            } else {
                _this.getRegions();
                if (document.getElementById("layer4-btn").disabled === true) {
                    document.getElementById("layer4-btn").disabled = false;
                }
            }
        };

        _this.onKeyUpServices = function (e) {
            var input = document.getElementById("inputTextDistribution");
            var textToBeSearch = "";
            if (input !== null) textToBeSearch = input.value;
            _this.appliedMarkersDistributionFilter(_this.state.valueDistributionSelect, textToBeSearch);
        };

        _this.handleOnClick = function () {
            _this.setState({
                popUpInfo: !_this.state.popUpInfo
            });
        };

        _this.createMarkerHistoricalStopsIndividually = function (dataStop) {

            if (dataStop !== undefined) {

                _this.setState({
                    historicalStopIndividuallyMarker: dataStop
                }, function () {
                    return _this.centerMap(dataStop.latitude, dataStop.longitude, 18);
                });
            } else {
                _this.setState({
                    historicalStopIndividuallyMarker: ""
                });
            }
        };

        _this.showCircle = function (centerCircle) {
            // console.log(centerCircle);
            if (_this.state.centerCircle === centerCircle) {
                _this.setState({
                    center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                    options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom }),
                    showCircleArea: !_this.state.showCircleArea,
                    showPopUpPoi: !_this.state.showPopUpPoi,
                    centerCircle: centerCircle,
                    optionsCircle: {
                        strokeColor: '#FF0000',
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: '#FF0000',
                        fillOpacity: 0.35,
                        clickable: false,
                        editable: false,
                        visible: true,
                        radius: centerCircle.radio,
                        zIndex: 1
                    }
                });
            } else {
                _this.setState({
                    center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                    options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom }),
                    centerCircle: centerCircle,
                    showCircleArea: true,
                    optionsCircle: {
                        strokeColor: '#FF0000',
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: '#FF0000',
                        fillOpacity: 0.35,
                        clickable: false,
                        editable: false,
                        visible: true,
                        radius: centerCircle.radio,
                        zIndex: 1
                    }
                });
            }
        };

        _this.closePopUpDeviceInfoWithCloseIcon = function () {
            _this.setState({
                popUpInfoDevice: false,
                device: [],
                address: "",
                center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom })
            });
        };

        _this.closePopUpDeviceInfo = function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(device, event) {
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                // console.log(event);
                                event.stopPropagation();
                                _this.handleMarkerClick(device, event); // Llama a la función y pasa el evento

                            case 2:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this2);
            }));

            return function (_x5, _x6) {
                return _ref5.apply(this, arguments);
            };
        }();

        _this.handleMarkerClick = function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(device, event) {
                var address;
                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                event.stopPropagation();

                                if (!(device.assetsInfoName !== _this.state.device.assetsInfoName)) {
                                    _context6.next = 8;
                                    break;
                                }

                                _context6.next = 4;
                                return _this.getAddress(device.gpsInfo.latitude, device.gpsInfo.longitude);

                            case 4:
                                address = _context6.sent;

                                _this.setState({
                                    popUpInfoDevice: true,
                                    historical: false,
                                    historicalInfoDevice: false,
                                    device: device,
                                    addressDevice: address,
                                    center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                                    options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom })
                                });
                                _context6.next = 9;
                                break;

                            case 8:
                                _this.setState({
                                    popUpInfoDevice: !_this.state.popUpInfoDevice,
                                    device: [],
                                    addressDevice: "",
                                    historicalInfoDevice: false
                                });

                            case 9:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this2);
            }));

            return function (_x7, _x8) {
                return _ref6.apply(this, arguments);
            };
        }();

        _this.isHistoricalInfoDeviceOpen = function () {
            _this.setState({
                historicalInfoDevice: false
            });
            // , () => {
            //     let input = document.getElementById("inputText");
            //     let textToBeSearch = "";
            //     if (input !== null)
            //         textToBeSearch = input.value;

            //     this.appliedMarkersVFilter(this.state.value, textToBeSearch, this.state.layerDevice);
            // })
        };

        _this.HistoricalInfoDeviceOpen = function () {
            _this.setState({
                historicalInfoDevice: true
            });
            // , () => {
            //     let input = document.getElementById("inputText");
            //     let textToBeSearch = "";
            //     if (input !== null)
            //         textToBeSearch = input.value;

            //     this.appliedMarkersVFilter(this.state.value, textToBeSearch, this.state.layerDevice);
            // })
        };

        _this.handleOnChangeDirection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
            var destination, origin, directions;
            return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            if (!(_this.state.directionsRenderer.directions !== undefined)) {
                                _context7.next = 28;
                                break;
                            }

                            if (!(_this.isEmpty(_this.state.directionsRenderer.directions.request.destination) === true)) {
                                _context7.next = 11;
                                break;
                            }

                            // let directionsChanged = this.state.directionsRenderer.getDirections();
                            // console.log(directionsChanged);
                            destination = "";

                            if (!(_this.state.destination === "")) {
                                _context7.next = 7;
                                break;
                            }

                            destination = new window.google.maps.LatLng(_this.state.directionsRenderer.directions.request.destination.location.lat(), _this.state.directionsRenderer.directions.request.destination.location.lng());
                            // await this.getAddress(this.state.directionsRenderer.directions.request.destination.location.lat(), this.state.directionsRenderer.directions.request.destination.location.lng());
                            _context7.next = 8;
                            break;

                        case 7:
                            return _context7.abrupt('return');

                        case 8:

                            _this.setState({
                                optionsRoute: {
                                    destination: destination,
                                    origin: _this.state.optionsRoute.origin,
                                    travelMode: "DRIVING"
                                },
                                destination: destination,
                                directionsRenderer: _this.state.directionsRenderer,
                                response: null,
                                center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                                options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom }),
                                isDragging: false
                            }, function () {

                                setTimeout(function () {
                                    _this.setState({
                                        destination: "",
                                        center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                                        options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom })
                                    });
                                }, 2000);
                            });
                            _context7.next = 28;
                            break;

                        case 11:
                            if (!(_this.isEmpty(_this.state.directionsRenderer.directions.request.origin) === true)) {
                                _context7.next = 21;
                                break;
                            }

                            origin = "";

                            if (!(_this.state.destination === "")) {
                                _context7.next = 17;
                                break;
                            }

                            origin = new window.google.maps.LatLng(_this.state.directionsRenderer.directions.request.origin.location.lat(), _this.state.directionsRenderer.directions.request.origin.location.lng());
                            // await this.getAddress(this.state.directionsRenderer.directions.request.origin.location.lat(), this.state.directionsRenderer.directions.request.origin.location.lng());
                            _context7.next = 18;
                            break;

                        case 17:
                            return _context7.abrupt('return');

                        case 18:
                            // let origin = await this.getAddress(this.state.directionsRenderer.directions.request.origin.lat(), this.state.directionsRenderer.directions.request.origin.lng());

                            _this.setState({
                                optionsRoute: Object.assign({}, _this.state.optionsRoute, {
                                    origin: origin,
                                    travelMode: 'DRIVING'
                                }),
                                destination: origin,
                                directionsRenderer: _this.state.directionsRenderer,
                                response: null,
                                center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                                options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom }),
                                isDragging: false
                            }, function () {
                                setTimeout(function () {
                                    _this.setState({
                                        destination: "",
                                        center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                                        options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom })
                                    });
                                }, 2000);
                            });
                            _context7.next = 28;
                            break;

                        case 21:
                            if (!_this.state.directionsRenderer.hasOwnProperty("dragResult")) {
                                _context7.next = 28;
                                break;
                            }

                            directions = _this.state.directionsRenderer.getDirections();

                            if (!(_this.state.isDragging === false)) {
                                _context7.next = 27;
                                break;
                            }

                            _this.setState({
                                response: "",
                                isDragging: true,
                                directionObjRouteToView: {
                                    distance: directions.routes[0].legs[0].distance.text,
                                    duration: directions.routes[0].legs[0].duration.text
                                },
                                center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                                options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom })
                            }, function () {
                                setTimeout(function () {
                                    _this.setState({
                                        isDragging: false,
                                        center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                                        options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom })
                                    });
                                }, 100);
                            });
                            _context7.next = 28;
                            break;

                        case 27:
                            return _context7.abrupt('return');

                        case 28:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this2);
        }));

        _this.filterForGroups = function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(id, e) {
                var groupDevicesCopy, i, element, _i, _element, spinnerLoading, checkBoxGroupIdsTmp, filter, data, _spinnerLoading;

                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                jsonGroups = localStorage.getItem("jsonGroups");
                                jsonGroups = JSON.parse(jsonGroups);

                                groupDevicesCopy = [].concat(_toConsumableArray(_this.state.groupsDevices));


                                for (i = 0; i < groupDevicesCopy.length; i++) {
                                    element = groupDevicesCopy[i];

                                    if (element.assetsTagsId == id) {
                                        element.isChecked = e.target.checked;
                                    }
                                }
                                for (_i = 0; _i < jsonGroups.length; _i++) {
                                    _element = jsonGroups[_i];

                                    if (_element.assetsTagsId == id) {
                                        _element.isChecked = e.target.checked;
                                    }
                                }
                                localStorage.setItem("jsonGroups", JSON.stringify(jsonGroups));

                                // this.setState({
                                //     groupsDevices {...this.state.groupsDevices, }
                                // })

                                if (e.target.checked) {
                                    _context8.next = 11;
                                    break;
                                }

                                spinnerLoading = document.getElementById("spinnerLoading");

                                _this.setState({
                                    center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                                    options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom }),
                                    checkBoxGroupIds: [].concat(_toConsumableArray(_this.state.checkBoxGroupIds), [id]),
                                    layerDevice: true
                                }, function () {
                                    spinnerLoading.style.display = "none";
                                    var input = document.getElementById("inputText");
                                    var textToBeSearch = "";
                                    if (input !== null) textToBeSearch = input.value;

                                    _this.appliedMarkersVFilter(_this.state.value, textToBeSearch, _this.state.checkBoxGroupIds);
                                    //let groupDevicesCopy = [...this.state.groupsDevices];
                                    //this.filterCheckboxGroup(null, groupDevicesCopy);
                                });
                                //this.filterCheckboxGroup(id, groupDevicesCopy);

                                _context8.next = 26;
                                break;

                            case 11:
                                checkBoxGroupIdsTmp = [].concat(_toConsumableArray(_this.state.checkBoxGroupIds));
                                filter = checkBoxGroupIdsTmp.filter(function (x) {
                                    return x != id;
                                });

                                if (filter == null) {
                                    filter = [];
                                }

                                _context8.prev = 14;
                                _context8.next = 17;
                                return _this.getDataFromIndexedDB();

                            case 17:
                                data = _context8.sent;

                                jsonIOInfo = data;
                                // Hacer algo con los datos recuperados
                                _context8.next = 24;
                                break;

                            case 21:
                                _context8.prev = 21;
                                _context8.t0 = _context8['catch'](14);

                                console.error('Error al obtener datos de IndexedDB:', _context8.t0);

                            case 24:
                                // jsonIOInfo = localStorage.getItem("jsonIOInfo");
                                // jsonIOInfo = JSON.parse(jsonIOInfo);
                                _spinnerLoading = document.getElementById("spinnerLoading");

                                _this.setState({
                                    center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                                    options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom }),
                                    checkBoxGroupIds: filter,
                                    layerDevice: true
                                }, function () {
                                    _spinnerLoading.style.display = "none";
                                    var input = document.getElementById("inputText");
                                    var textToBeSearch = "";
                                    if (input !== null) textToBeSearch = input.value;

                                    _this.appliedMarkersVFilter(_this.state.value, textToBeSearch, _this.state.checkBoxGroupIds);
                                    //let groupDevicesCopy = [...this.state.groupsDevices];
                                    //this.filterCheckboxGroup(null, groupDevicesCopy);
                                });

                            case 26:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this2, [[14, 21]]);
            }));

            return function (_x9, _x10) {
                return _ref8.apply(this, arguments);
            };
        }();

        _this.filterForDevice = function (assetsInfoImeiParam, checked) {

            var groupsDevicesCopy = [];
            if (!checked) {
                jsonInfo = localStorage.getItem("jsonInfo");
                jsonInfo = JSON.parse(jsonInfo);

                var result = [];
                var jsonInfoTmp = jsonInfo;

                result = jsonInfoTmp.filter(function (x) {
                    return x.assetsTagsId != assetsInfoImeiParam;
                });
                //console.log(result);
                jsonInfoTmp = result;

                var group = _this.state.groupsDevices.filter(function (elem) {
                    return elem.assetsTagInfo.find(function (_ref9) {
                        var assetsInfoImei = _ref9.assetsInfoImei;
                        return assetsInfoImei == assetsInfoImeiParam;
                    });
                });

                if (group.length > 0) {
                    var infoGroup = group[0].assetsTagInfo.filter(function (x) {
                        return x.assetsInfoImei == assetsInfoImeiParam;
                    });

                    infoGroup[0].isChecked = checked;

                    groupsDevicesCopy = [].concat(_toConsumableArray(_this.state.groupsDevices));

                    for (var i = 0; i < groupsDevicesCopy.length; i++) {
                        var element = groupsDevicesCopy[i];
                        if (element.assetsTagsId == infoGroup[0].assetsTagsId) {
                            element = infoGroup[0];
                        }
                    }
                }

                var assetsInfo = {
                    assetsInfoImei: assetsInfoImeiParam,
                    isChecked: checked
                };

                var insert = _this.state.assetsInfoImeiArrFilter.some(function (x) {
                    return x.assetsInfoImei == assetsInfoImeiParam;
                });

                var spinnerLoading = document.getElementById("spinnerLoading");
                _this.setState({
                    center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                    options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom }),
                    layerDevice: true,
                    assetsInfoImeiArrFilter: insert == false ? [].concat(_toConsumableArray(_this.state.assetsInfoImeiArrFilter), [assetsInfo]) : _this.state.assetsInfoImeiArrFilter
                }, function () {
                    spinnerLoading.style.display = "none";

                    var input = document.getElementById("inputText");
                    var textToBeSearch = "";
                    if (input !== null) textToBeSearch = input.value;

                    _this.appliedMarkersVFilter(_this.state.value, textToBeSearch, _this.state.checkBoxGroupIds);
                });
            } else {

                jsonIOInfo = _this.state.markersV;

                var assetsInfoImeiItemFilter = _this.state.assetsInfoImeiArrFilter.filter(function (x) {
                    return x.assetsInfoImei != assetsInfoImeiParam;
                });

                var _group = _this.state.groupsDevices.filter(function (elem) {
                    return elem.assetsTagInfo.find(function (_ref10) {
                        var assetsInfoImei = _ref10.assetsInfoImei;
                        return assetsInfoImei == assetsInfoImeiParam;
                    });
                });
                var _infoGroup = _group[0].assetsTagInfo.filter(function (x) {
                    return x.assetsInfoImei == assetsInfoImeiParam;
                });

                _infoGroup[0].isChecked = checked;

                var _groupsDevicesCopy = [].concat(_toConsumableArray(_this.state.groupsDevices));

                for (var _i2 = 0; _i2 < _groupsDevicesCopy.length; _i2++) {
                    var _element2 = _groupsDevicesCopy[_i2];
                    if (_element2.assetsTagsId == _infoGroup[0].assetsTagsId) {
                        _element2 = _infoGroup[0];
                    }
                }
                var deviceInfoFilter = jsonIOInfo.filter(function (x) {
                    return x.assetsIOTImei == assetsInfoImeiParam;
                });

                var copyMakersV = [].concat(_toConsumableArray(_this.state.markersV));

                copyMakersV.push(deviceInfoFilter[0]);
                var _spinnerLoading2 = document.getElementById("spinnerLoading");
                _this.setState({
                    center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                    options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom }),
                    layerDevice: true,
                    assetsInfoImeiArrFilter: assetsInfoImeiItemFilter
                }, function () {
                    _spinnerLoading2.style.display = "none";
                    var input = document.getElementById("inputText");
                    var textToBeSearch = "";
                    if (input !== null) textToBeSearch = input.value;

                    _this.appliedMarkersVFilter(_this.state.value, textToBeSearch, _this.state.checkBoxGroupIds);
                });
            }
        };

        _this.handleCheckboxPoisChange = function (id, isGroup) {
            _this.setState(function (prevState) {
                var updatedGroupPois = prevState.groupsPois.map(function (grupo) {
                    if (isGroup && grupo.idTipo === id || !isGroup && grupo.idTipo === id) {
                        var updatedGrupo = Object.assign({}, grupo, {
                            isChecked: !grupo.isChecked,
                            center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                            options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom }),
                            poisInfo: isGroup ? grupo.poisInfo.map(function (poi) {
                                return Object.assign({}, poi, {
                                    isChecked: !grupo.isChecked
                                });
                            }) : grupo.poisInfo
                        });

                        return updatedGrupo;
                    }

                    return grupo;
                });
                var center = { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() };
                var options = Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom });

                // Actualizar array original directamente
                var updatedOriginalGroupPois = _this.updateOriginalGroupPois(prevState.originalGroupPois, updatedGroupPois);

                return { groupsPois: updatedGroupPois, originalGroupPois: updatedOriginalGroupPois, center: center, options: options };
            });
        };

        _this.handleCheckboxPoiChange = function (id) {
            _this.setState(function (prevState) {
                var updatedGroupsPois = prevState.groupsPois.map(function (grupo) {
                    var updatedPoisInfo = grupo.poisInfo.map(function (poi) {
                        if (poi.idPoi === id) {
                            // Toggle isChecked para la región individual
                            return Object.assign({}, poi, {
                                isChecked: !poi.isChecked
                            });
                        }
                        return poi;
                    });

                    return Object.assign({}, grupo, {
                        poisInfo: updatedPoisInfo
                    });
                });

                // Actualizar array original
                var updatedOriginalGroupPois = _this.updateOriginalGroupPois(prevState.originalGroupPois, updatedGroupsPois);

                var center = { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() };
                var options = Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom });
                return {
                    groupsPois: updatedGroupsPois,
                    originalGroupPois: updatedOriginalGroupPois,
                    center: center,
                    options: options
                };
            });
        };

        _this.handleCheckboxRegionsChange = function (id, isGroup) {
            _this.setState(function (prevState) {
                var updatedGroupRegions = prevState.groupRegions.map(function (grupo) {
                    if (isGroup && grupo.idTipoRegion === id || !isGroup && grupo.idTipoRegion === id) {
                        var updatedGrupo = Object.assign({}, grupo, {
                            isChecked: !grupo.isChecked,
                            center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                            options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom }),
                            regiones: isGroup ? grupo.regiones.map(function (region) {
                                return Object.assign({}, region, {
                                    isChecked: !grupo.isChecked
                                });
                            }) : grupo.regiones
                        });

                        return updatedGrupo;
                    }

                    return grupo;
                });
                var center = { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() };
                var options = Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom });

                // Actualizar array original directamente
                var updatedOriginalGroupRegions = _this.updateOriginalGroupRegions(prevState.originalGroupRegions, updatedGroupRegions);

                return { groupRegions: updatedGroupRegions, originalGroupRegions: updatedOriginalGroupRegions, center: center, options: options };
            });
        };

        _this.handleCheckboxRegionChange = function (id) {
            _this.setState(function (prevState) {
                var updatedGroupsRegions = prevState.groupRegions.map(function (grupo) {
                    var updatedRegionsInfo = grupo.regiones.map(function (region) {
                        if (region.idRegion === id) {
                            // Toggle isChecked para la región individual
                            return Object.assign({}, region, {
                                isChecked: !region.isChecked
                            });
                        }
                        return region;
                    });

                    return Object.assign({}, grupo, {
                        regiones: updatedRegionsInfo
                    });
                });

                // Actualizar array original
                var updatedOriginalGroupRegions = _this.updateOriginalGroupRegions(prevState.originalGroupRegions, updatedGroupsRegions);

                var center = { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() };
                var options = Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom });

                return {
                    groupRegions: updatedGroupsRegions,
                    originalGroupRegions: updatedOriginalGroupRegions,
                    center: center,
                    options: options
                };
            });
        };

        _this.updateOriginalGroupPois = function (originalGroupPois, updatedGroupPois) {
            return originalGroupPois.map(function (originalGrupo) {
                var matchingGroup = updatedGroupPois.find(function (updatedGrupo) {
                    return updatedGrupo.idTipo === originalGrupo.idTipo;
                });

                if (matchingGroup) {
                    var updatedPois = originalGrupo.poisInfo.map(function (originalPoi) {
                        // Marcar todas las regiones del grupo si el grupo está marcado
                        return Object.assign({}, originalPoi, {
                            isChecked: matchingGroup.isChecked
                        });
                    });

                    return Object.assign({}, originalGrupo, {
                        poisInfo: updatedPois,
                        isChecked: matchingGroup.isChecked || originalGrupo.isChecked
                    });
                }
                return originalGrupo;
            });
        };

        _this.onKeyUpPois = function (event) {
            var searchText = event.target.value.toLowerCase();

            _this.setState(function (prevState) {
                // Si el texto de búsqueda está vacío y la opción es "todos", restaurar el estado original
                if (!searchText && _this.state.valueSelectPois.value === 'todos') {
                    var allOriginalGroupPois = prevState.originalGroupPois.map(function (originalGrupo) {
                        return Object.assign({}, originalGrupo, {
                            isChecked: true, // Marcar el grupo
                            poisInfo: originalGrupo.poisInfo.map(function (originalPoi) {
                                return Object.assign({}, originalPoi, {
                                    isChecked: true // Marcar la región
                                });
                            })
                        });
                    });

                    return {
                        groupsPois: allOriginalGroupPois,
                        searchText: '',
                        selectedPois: allOriginalGroupPois.reduce(function (selected, grupo) {
                            return selected.concat(grupo.poisInfo);
                        }, []),
                        center: {
                            lat: _this.state.actualMap.center.lat(),
                            lng: _this.state.actualMap.center.lng()
                        },
                        options: Object.assign({}, _this.state.options, {
                            zoom: _this.state.actualMap.zoom
                        })
                    };
                } else {
                    if (!searchText) {
                        var hasCheckedPoiOrGroup = prevState.groupsPois.some(function (grupo) {
                            return grupo.isChecked || grupo.poisInfo.some(function (poi) {
                                return poi.isChecked;
                            });
                        });

                        var allOriginalGroupPoi = prevState.originalGroupPois.map(function (originalGrupo) {
                            var matchingGroup = prevState.groupsPois.find(function (grupo) {
                                return grupo.idTipo === originalGrupo.idTipo;
                            });

                            if (matchingGroup) {
                                return Object.assign({}, originalGrupo, {
                                    isChecked: hasCheckedPoiOrGroup ? matchingGroup.isChecked : false,
                                    poisInfo: originalGrupo.poisInfo.map(function (originalPoi) {
                                        var matchingRegion = matchingGroup.poisInfo.find(function (poi) {
                                            return poi.idPoi === originalPoi.idPoi;
                                        });

                                        return matchingRegion ? Object.assign({}, originalPoi, { isChecked: hasCheckedPoiOrGroup ? matchingRegion.isChecked : false }) : originalPoi;
                                    })
                                });
                            }

                            return originalGrupo;
                        });

                        _this.setState({
                            center: {
                                lat: _this.state.actualMap.center.lat(),
                                lng: _this.state.actualMap.center.lng()
                            },
                            options: Object.assign({}, _this.state.options, {
                                zoom: _this.state.actualMap.zoom
                            }),
                            groupsPois: allOriginalGroupPoi,
                            searchText: '',
                            selectedPois: allOriginalGroupPoi.reduce(function (selected, grupo) {
                                return selected.concat(grupo.poisInfo);
                            }, [])
                        });
                    }
                }

                // Filtrar los grupos basados en el texto de búsqueda
                var filteredGroupRegions = prevState.groupRegions.map(function (grupo) {
                    return Object.assign({}, grupo, {
                        regiones: grupo.regiones.filter(function (region) {
                            return region.nombreRegion.toLowerCase().includes(searchText);
                        })
                    });
                }).filter(function (grupo) {
                    return grupo.regiones.length > 0;
                });

                // Aplicar las selecciones guardadas nuevamente después de aplicar el filtro
                var selectedRegions = _this.getSelectedRegions(prevState, filteredGroupRegions);
                var center = { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() };
                var options = Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom });

                // Actualizar el estado con los grupos filtrados y las selecciones
                return { groupRegions: filteredGroupRegions, searchText: searchText, selectedRegions: selectedRegions, center: center, options: options };
            });

            _this.setState(function (prevState) {
                // Si el texto de búsqueda está vacío y la opción es "todos", restaurar el estado original
                if (!searchText && _this.state.valueSelectPois.value === 'todos') {
                    var hasCheckedPoiOrGroup = prevState.groupsPois.some(function (grupo) {
                        return grupo.isChecked || grupo.poisInfo.some(function (poi) {
                            return poi.isChecked;
                        });
                    });

                    var allOriginalGroupPois = prevState.originalGroupPois.map(function (originalGrupo) {
                        var matchingGroup = prevState.groupsPois.find(function (grupo) {
                            return grupo.idTipo === originalGrupo.idTipo;
                        });

                        if (matchingGroup) {
                            return Object.assign({}, originalGrupo, {
                                isChecked: hasCheckedPoiOrGroup ? matchingGroup.isChecked : false,
                                poisInfo: originalGrupo.poisInfo.map(function (originalPoi) {
                                    var matchingPoi = matchingGroup.poisInfo.find(function (poi) {
                                        return poi.idPoi === originalPoi.idPoi;
                                    });

                                    return matchingPoi ? Object.assign({}, originalPoi, { isChecked: hasCheckedPoiOrGroup ? matchingPoi.isChecked : false }) : originalPoi;
                                })
                            });
                        }

                        return originalGrupo;
                    });

                    _this.setState({
                        center: {
                            lat: _this.state.actualMap.center.lat(),
                            lng: _this.state.actualMap.center.lng()
                        },
                        options: Object.assign({}, _this.state.options, {
                            zoom: _this.state.actualMap.zoom
                        }),
                        groupsPois: allOriginalGroupPois,
                        searchText: '',
                        selectedPois: allOriginalGroupPois.reduce(function (selected, grupo) {
                            return selected.concat(grupo.poisInfo);
                        }, [])
                    });
                } else {
                    if (!searchText) {
                        var _hasCheckedPoiOrGroup = prevState.groupsPois.some(function (grupo) {
                            return grupo.isChecked || grupo.poisInfo.some(function (poi) {
                                return poi.isChecked;
                            });
                        });

                        var _allOriginalGroupPois = prevState.originalGroupPois.map(function (originalGrupo) {
                            var matchingGroup = prevState.groupsPois.find(function (grupo) {
                                return grupo.idTipo === originalGrupo.idTipo;
                            });

                            if (matchingGroup) {
                                return Object.assign({}, originalGrupo, {
                                    isChecked: _hasCheckedPoiOrGroup ? matchingGroup.isChecked : false,
                                    poisInfo: originalGrupo.poisInfo.map(function (originalPoi) {
                                        var matchingPoi = matchingGroup.poisInfo.find(function (poi) {
                                            return poi.idPoi === originalPoi.idPoi;
                                        });

                                        return matchingPoi ? Object.assign({}, originalPoi, { isChecked: _hasCheckedPoiOrGroup ? matchingPoi.isChecked : false }) : originalPoi;
                                    })
                                });
                            }

                            return originalGrupo;
                        });

                        _this.setState({
                            center: {
                                lat: _this.state.actualMap.center.lat(),
                                lng: _this.state.actualMap.center.lng()
                            },
                            options: Object.assign({}, _this.state.options, {
                                zoom: _this.state.actualMap.zoom
                            }),
                            groupsPois: _allOriginalGroupPois,
                            searchText: '',
                            selectedPois: _allOriginalGroupPois.reduce(function (selected, grupo) {
                                return selected.concat(grupo.poisInfo);
                            }, [])
                        });
                    }
                }

                // Filtrar los grupos basados en el texto de búsqueda
                var filteredGroupPois = prevState.groupsPois.map(function (grupo) {
                    return Object.assign({}, grupo, {
                        poisInfo: grupo.poisInfo.filter(function (poi) {
                            return poi.cliente.toLowerCase().includes(searchText);
                        })
                    });
                }).filter(function (grupo) {
                    return grupo.poisInfo.length > 0;
                });

                // Aplicar las selecciones guardadas nuevamente después de aplicar el filtro
                var selectedPois = _this.getSelectedPois(prevState, filteredGroupPois);
                var center = { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() };
                var options = Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom });

                // Actualizar el estado con los grupos filtrados y las selecciones
                return { groupsPois: filteredGroupPois, searchText: searchText, selectedPois: selectedPois, center: center, options: options };
            });
        };

        _this.handleSearchTextRegionsChange = function (event) {
            var searchText = event.target.value.toLowerCase();

            _this.setState(function (prevState) {
                // Si el texto de búsqueda está vacío y la opción es "todos", restaurar el estado original
                if (!searchText && _this.state.valueSelectRegiones.value === 'todos') {
                    var allOriginalGroupRegions = prevState.originalGroupRegions.map(function (originalGrupo) {
                        return Object.assign({}, originalGrupo, {
                            isChecked: true, // Marcar el grupo
                            regiones: originalGrupo.regiones.map(function (originalRegion) {
                                return Object.assign({}, originalRegion, {
                                    isChecked: true // Marcar la región
                                });
                            })
                        });
                    });

                    return {
                        groupRegions: allOriginalGroupRegions,
                        searchText: '',
                        selectedRegions: allOriginalGroupRegions.reduce(function (selected, grupo) {
                            return selected.concat(grupo.regiones);
                        }, []),
                        center: {
                            lat: _this.state.actualMap.center.lat(),
                            lng: _this.state.actualMap.center.lng()
                        },
                        options: Object.assign({}, _this.state.options, {
                            zoom: _this.state.actualMap.zoom
                        })
                    };
                } else {
                    if (!searchText) {
                        var hasCheckedRegionOrGroup = prevState.groupRegions.some(function (grupo) {
                            return grupo.isChecked || grupo.regiones.some(function (region) {
                                return region.isChecked;
                            });
                        });

                        var _allOriginalGroupRegions = prevState.originalGroupRegions.map(function (originalGrupo) {
                            var matchingGroup = prevState.groupRegions.find(function (grupo) {
                                return grupo.idTipoRegion === originalGrupo.idTipoRegion;
                            });

                            if (matchingGroup) {
                                return Object.assign({}, originalGrupo, {
                                    isChecked: hasCheckedRegionOrGroup ? matchingGroup.isChecked : false,
                                    regiones: originalGrupo.regiones.map(function (originalRegion) {
                                        var matchingRegion = matchingGroup.regiones.find(function (region) {
                                            return region.idRegion === originalRegion.idRegion;
                                        });

                                        return matchingRegion ? Object.assign({}, originalRegion, { isChecked: hasCheckedRegionOrGroup ? matchingRegion.isChecked : false }) : originalRegion;
                                    })
                                });
                            }

                            return originalGrupo;
                        });

                        _this.setState({
                            center: {
                                lat: _this.state.actualMap.center.lat(),
                                lng: _this.state.actualMap.center.lng()
                            },
                            options: Object.assign({}, _this.state.options, {
                                zoom: _this.state.actualMap.zoom
                            }),
                            groupRegions: _allOriginalGroupRegions,
                            searchText: '',
                            selectedRegions: _allOriginalGroupRegions.reduce(function (selected, grupo) {
                                return selected.concat(grupo.regiones);
                            }, [])
                        });
                    }
                }

                // Filtrar los grupos basados en el texto de búsqueda
                var filteredGroupRegions = prevState.groupRegions.map(function (grupo) {
                    return Object.assign({}, grupo, {
                        regiones: grupo.regiones.filter(function (region) {
                            return region.nombreRegion.toLowerCase().includes(searchText);
                        })
                    });
                }).filter(function (grupo) {
                    return grupo.regiones.length > 0;
                });

                // Aplicar las selecciones guardadas nuevamente después de aplicar el filtro
                var selectedRegions = _this.getSelectedRegions(prevState, filteredGroupRegions);
                var center = { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() };
                var options = Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom });

                // Actualizar el estado con los grupos filtrados y las selecciones
                return { groupRegions: filteredGroupRegions, searchText: searchText, selectedRegions: selectedRegions, center: center, options: options };
            });
        };

        _this.getSelectedRegions = function (prevState, filteredGroupRegions) {
            return (prevState.selectedRegions || []).reduce(function (selected, selectedRegion) {
                // Verificar si se ha filtrado algún grupo
                if (filteredGroupRegions && Array.isArray(filteredGroupRegions)) {
                    // Buscar la región seleccionada en los grupos filtrados
                    var matchingGroup = filteredGroupRegions.find(function (grupo) {
                        return grupo.idTipoRegion === selectedRegion.idTipoRegion;
                    });

                    if (matchingGroup) {
                        // Verificar si el grupo filtrado tiene la propiedad 'regiones' y es un array
                        if (matchingGroup.regiones && Array.isArray(matchingGroup.regiones)) {
                            // Buscar la región seleccionada dentro del grupo filtrado
                            var matchingRegion = matchingGroup.regiones.find(function (region) {
                                return region.idRegion === selectedRegion.idRegion;
                            });

                            if (matchingRegion) {
                                // Agregar la región seleccionada a las regiones seleccionadas
                                selected.push(matchingRegion);
                            }
                        }
                    }
                }

                return selected;
            }, []);
        };

        _this.updateOriginalGroupRegions = function (originalGroupRegions, updatedGroupRegions) {
            return originalGroupRegions.map(function (originalGrupo) {
                var matchingGroup = updatedGroupRegions.find(function (updatedGrupo) {
                    return updatedGrupo.idTipoRegion === originalGrupo.idTipoRegion;
                });

                if (matchingGroup) {
                    var updatedRegions = originalGrupo.regiones.map(function (originalRegion) {
                        // Marcar todas las regiones del grupo si el grupo está marcado
                        return Object.assign({}, originalRegion, {
                            isChecked: matchingGroup.isChecked
                        });
                    });

                    return Object.assign({}, originalGrupo, {
                        regiones: updatedRegions,
                        isChecked: matchingGroup.isChecked || originalGrupo.isChecked
                    });
                }
                return originalGrupo;
            });
        };

        _this.getSelectedPois = function (prevState, filteredGroupPois) {
            return (prevState.selectedPois || []).reduce(function (selected, selectedPois) {
                // Verificar si se ha filtrado algún grupo
                if (filteredGroupPois && Array.isArray(filteredGroupPois)) {
                    // Buscar la región seleccionada en los grupos filtrados
                    var matchingGroup = filteredGroupPois.find(function (grupo) {
                        return grupo.idTipoRegion === selectedPois.idTipoRegion;
                    });

                    if (matchingGroup) {
                        // Verificar si el grupo filtrado tiene la propiedad 'regiones' y es un array
                        if (matchingGroup.regiones && Array.isArray(matchingGroup.regiones)) {
                            // Buscar la región seleccionada dentro del grupo filtrado
                            var matchingPoi = matchingGroup.regiones.find(function (region) {
                                return region.idPoi === selectedPois.idPoi;
                            });

                            if (matchingPoi) {
                                // Agregar la región seleccionada a las regiones seleccionadas
                                selected.push(matchingPoi);
                            }
                        }
                    }
                }

                return selected;
            }, []);
        };

        _this.handleOnChangeSelectRegions = function (newSelection) {
            var selectAll = newSelection.value === 'todos';

            // Actualizar la selección en el array de grupos y regiones
            var groupRegions = _this.state.groupRegions;
            groupRegions.forEach(function (element) {
                element.isChecked = selectAll;
                element.regiones.forEach(function (regiones) {
                    regiones.isChecked = selectAll;
                });
            });

            // Actualizar el array original también
            var originalGroupRegions = _this.updateOriginalGroupRegions(_this.state.originalGroupRegions, groupRegions);

            _this.setState({
                groupRegions: groupRegions,
                originalGroupRegions: originalGroupRegions,
                selectAll: selectAll,
                valueSelectRegiones: newSelection,
                center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom })
            });
        };

        _this.handleOnChangeSelectPois = function (newSelection) {
            var selectAll = newSelection.value === 'todos';

            // Actualizar la selección en el array de grupos y regiones
            var groupPois = _this.state.groupsPois;
            groupPois.forEach(function (element) {
                element.isChecked = selectAll;
                element.poisInfo.forEach(function (poi) {
                    poi.isChecked = selectAll;
                });
            });

            // Actualizar el array original también
            var originalGroupPois = _this.updateOriginalGroupPois(_this.state.originalGroupPois, groupPois);

            _this.setState({
                groupsPois: groupPois,
                originalGroupPois: originalGroupPois,
                selectAll: selectAll,
                valueSelectPois: newSelection,
                center: { lat: _this.state.actualMap.center.lat(), lng: _this.state.actualMap.center.lng() },
                options: Object.assign({}, _this.state.options, { zoom: _this.state.actualMap.zoom })
            });
        };

        _this.state = {
            markersV: _this.props.markersV !== null ? _this.props.markersV.length > 0 ? _this.props.markersV : [] : [],
            layerDevice: true,
            layerDistribution: false,
            layerPois: false,
            layerRegions: false,
            address: '',
            groupsDevices: _this.props.groupsDevices !== null ? _this.props.groupsDevices.length > 0 ? _this.props.groupsDevices : [] : [],
            groupsTasksServices: [],
            groupsPois: [],
            originalGroupPois: [],
            groupRegions: [],
            originalGroupRegions: [],
            filter: OptionsProfiles,
            value: [],
            valueDistributionSelect: [],
            valueSearchFilter: '',
            urlApi: _this.props.urlApi,
            historicalStopIndividuallyMarker: "",
            showCircleArea: false,
            optionsCircle: {},
            popUpInfoDevice: false,
            historicalInfoDevice: false,
            showPopUpPoi: true,
            actualZoom: '',
            jsonPoisInfo: [],
            options: {
                mapTypeId: _this.props.profiles !== null ? _this.props.profiles.length > 0 ? _this.props.profiles[0].options.mapTypeId : 'roadmap' : 'roadmap',
                gestureHandling: _this.props.profiles !== null ? _this.props.profiles.length > 0 ? _this.props.profiles[0].options.gestureHandling : 'greedy' : 'greedy',
                disableDefaultUI: _this.props.profiles !== null ? _this.props.profiles.length > 0 ? _this.props.profiles[0].options.disableDefaultUI : false : false,
                mapTypeControl: false,
                zoom: _this.props.profiles !== null ? _this.props.profiles.length > 0 ? _this.props.profiles[0].options.zoom : 3 : 3,
                minZoom: 3,
                clickableIcons: false,
                restriction: {
                    latLngBounds: {
                        north: 85,
                        south: -85,
                        west: -180,
                        east: 180
                    }
                },
                strictBounds: false
            },
            // center: {
            //     lat: this.props.profiles !== null ? this.props.profiles.length > 0 ? this.props.profiles[0].center.lat : 8.13300317890294 : 8.13300317890294,
            //     lng: this.props.profiles !== null ? this.props.profiles.length > 0 ? this.props.profiles[0].center.lng : -39.003728314371244 : -39.003728314371244
            // },
            center: { lat: 40.4509, lng: -3.7213 },
            isTrafficLayerShown: _this.props.profiles !== null ? _this.props.profiles.length > 0 ? _this.props.profiles[0].isTrafficLayerShown : false : false,
            keyGoogleMaps: _this.props.googleMapsApiKey,
            accessToken: _this.props.accessToken,
            centerDevice: { assetsIOTImei: 0 },
            // isOpenDeviceContent: false,
            device: [],
            addressDevice: "",
            historical: false,
            actualMap: {},
            count: 0,
            markersDisplay: false,
            isShown: false,
            permisionDistribution: false,
            permisionPois: false,
            permisionRegiones: false,
            permisionHistory: false,
            permisionActivator: false,
            AdminPermision: false,
            optionsDistribution: [
                // { value: 'fuera de tiempo', label: 'Fuera de Tiempo' },
                // { value: 'noGPS', label: 'No-GPS' },
                // { value: 'noGPRS', label: 'No-GPRS' },
                // { value: 'noInstal', label: 'No-Instal' }
            ],
            optionsFiltersDevices: [
                // { value: 'noGPS', label: 'No-GPS' },
                // { value: 'noInstal', label: 'No-Instal' }
            ],
            optionsFilterSelectRegiones: [{ value: "ninguno", label: 'Ninguno' }, { value: 'todos', label: 'Todos' }],
            objWhenClickOnMap: {
                lat: 0,
                lng: 0,
                latView: 0,
                lngView: 0,
                address: "",
                visible: false,
                markerVisible: false
            },
            isOpenTooltip: false,
            optionsRoute: {
                // destination: 'Calle Practicante Ignacio Rodríguez',
                // origin: 'Calle Madroño, 12, 35110 Vecindario,',
                // travelMode: 'DRIVING'
                destination: '',
                // new window.google.maps.LatLng(27.845577, -15.445033),
                origin: '',
                // new window.google.maps.LatLng(27.870012, -15.430700),
                travelMode: 'DRIVING'
            },
            markerPositionToDirectionRoute: {
                lat: 0,
                lng: 0,
                visible: false
            },
            response: null,
            directionObjRouteToView: {
                duration: "",
                distance: ""
            },
            directionsRenderer: "",
            isUpdate: false,
            destination: "",
            isDragging: false,
            isInIframe: false,
            checkBoxGroupIds: [],
            assetsInfoImeiArrFilter: [],
            searchTextRegionsInput: "",
            valueSelectRegiones: [],
            valueSelectPois: [],
            searchTextPoisInput: "",
            isVehicleGrouped: true
            // this.timerID = setInterval(() => {
            //     this.getAssetsIOT("1");
            // }, 20000);

        };_this.clusterer = MarkerClusterer;
        _this.actualMap = {};
        _this.directionsRef = "";
        _this.mapRef = React.createRef();

        return _this;
    }

    _createClass(Map, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var t = this.props.t;

            var permisionDistribution = false;
            var permisionPois = false;
            var permisionHistory = false;
            var permisionActivator = false;
            var permisionRegiones = false;

            var isInIframe = this.props.origin;

            //this.getRegions();

            // this.state.directionsRenderer.addEventListener("directions_changed", this.computeTotalDistance(this.state.directionsRenderer.getDirections()));
            // this.state.directionsRenderer.addListener("directions_changed", () => {

            // });


            var optionsDistribution = [{ tag: "En Proceso", value: 'en proceso', label: t("map.sidebar.filterDistribution.inProgress") }, { tag: "Finalizado", value: 'finalizado', label: t("map.sidebar.filterDistribution.finalized") }];
            var optionsFiltersDevices = [{ tag: "Circulando", value: 'circulando', label: t("map.sidebar.filtersDevices.driving") }, { tag: "Parado", value: 'parado', label: t("map.sidebar.filtersDevices.stop") }, { tag: "Estacionado", value: 'estacionado', label: t("map.sidebar.filtersDevices.parked") },
            // { value: 'noGPS', label: 'No-GPS' },
            { tag: "NoGprs", value: 'noGPRS', label: t("map.sidebar.filtersDevices.noGprs") }, { tag: "NoGps", value: 'noGps', label: "No-GPS" }, { tag: "NoInstalacion", value: 'noInstalacion', label: "Pendiente de instalación" }];
            if (this.props.userDataInfo !== undefined) {
                var accessPermisionDistribution = this.props.userDataInfo.accessPermision.search("pD4service");
                var accessPermisionPois = this.props.userDataInfo.accessPermision.search("pVisualizacionPois");
                var accessPermisionHistory = this.props.userDataInfo.accessPermision.search("pVisualizacionHistorico");
                //let adminPermisionUsers = this.props.userDataInfo.accessPermision.search("pAdministracionUsuarios");
                var accessPermisionActivator = this.props.userDataInfo.accessPermision.search("pVisualizacionActivadores");
                var accessPermisionRegiones = this.props.userDataInfo.accessPermision.search("pVisualizacionRegiones");

                permisionHistory = accessPermisionHistory !== -1;
                permisionDistribution = accessPermisionDistribution !== -1;
                permisionPois = accessPermisionPois !== -1;
                permisionActivator = accessPermisionActivator !== -1;
                permisionRegiones = accessPermisionRegiones !== -1;

                this.setState({
                    permisionPois: permisionPois,
                    permisionDistribution: permisionDistribution,
                    permisionHistory: permisionHistory,
                    permisionRegiones: permisionRegiones,
                    permisionActivator: permisionActivator,
                    optionsDistribution: optionsDistribution,
                    optionsFiltersDevices: optionsFiltersDevices,
                    isInIframe: isInIframe
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearIntervalDevices();
            this.clearIntervalServices();
        }
    }, {
        key: 'handleOnChange',
        value: function handleOnChange(newSelection) {
            if (newSelection === null) {
                newSelection = [];
            }

            var input = document.getElementById("inputText");
            var textToBeSearch = "";
            if (input !== null) textToBeSearch = input.value;

            this.appliedMarkersVFilter(newSelection, textToBeSearch, this.state.checkBoxGroupIds);
        }
    }, {
        key: 'getRegions',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                var responseRegions, i, element, j, elementContent;
                return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return fetch(this.state.urlApi + "Regions", {
                                    headers: {
                                        'accessToken': this.props.accessToken
                                    }
                                });

                            case 2:
                                responseRegions = _context9.sent;

                                if (!responseRegions.ok) {
                                    _context9.next = 12;
                                    break;
                                }

                                _context9.next = 6;
                                return responseRegions.json();

                            case 6:
                                jsonRegions = _context9.sent;

                                for (i = 0; i < jsonRegions.length; i++) {
                                    element = Object.assign({}, jsonRegions[i], { isChecked: false });

                                    jsonRegions[i] = element;
                                    for (j = 0; j < jsonRegions[i].regiones.length; j++) {
                                        elementContent = Object.assign({}, jsonRegions[i].regiones[j], { isChecked: false });

                                        jsonRegions[i].regiones[j] = elementContent;
                                    }
                                }
                                //console.log(jsonRegions)
                                this.setState({
                                    groupRegions: jsonRegions,
                                    originalGroupRegions: jsonRegions,
                                    layerRegions: true,
                                    center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
                                    options: Object.assign({}, this.state.options, { zoom: this.state.actualMap.zoom })
                                });
                                localStorage.setItem("jsonRegions", JSON.stringify(jsonRegions));
                                _context9.next = 13;
                                break;

                            case 12:
                                alert("HTTP-Error: " + responseRegions.status);

                            case 13:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function getRegions() {
                return _ref11.apply(this, arguments);
            }

            return getRegions;
        }()
    }, {
        key: 'getTaskOrders',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
                var responseTasksOrders, input, textToBeSearch;
                return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return fetch(this.state.urlApi + "TaskOrders", {
                                    headers: {
                                        'destinations': true,
                                        'products': true,
                                        'accessToken': this.props.accessToken
                                    }
                                });

                            case 2:
                                responseTasksOrders = _context10.sent;

                                if (!responseTasksOrders.ok) {
                                    _context10.next = 10;
                                    break;
                                }

                                _context10.next = 6;
                                return responseTasksOrders.json();

                            case 6:
                                jsonTasksOrders = _context10.sent;

                                localStorage.setItem("jsonGroupsService", JSON.stringify(jsonTasksOrders));
                                _context10.next = 11;
                                break;

                            case 10:
                                alert("HTTP-Error: " + responseTasksOrders.status);

                            case 11:
                                input = document.getElementById("inputText");
                                textToBeSearch = "";

                                if (input !== null) textToBeSearch = input.value;

                                this.appliedMarkersDistributionFilter(this.state.valueDistributionSelect, textToBeSearch, this.state.layerDistribution);

                                // this.setState({
                                //     groupsTasksServices: jsonTasksOrders
                                // }, () => spinnerLoading.style.display = "none");

                            case 15:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function getTaskOrders() {
                return _ref12.apply(this, arguments);
            }

            return getTaskOrders;
        }()
    }, {
        key: 'getTasksOrdersWithoutDestinations',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
                var responseTasksOrdersServices;
                return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return fetch(this.state.urlApi + "TaskOrders", {
                                    headers: {
                                        'destinations': false,
                                        'products': false,
                                        'accessToken': this.props.accessToken
                                    }
                                });

                            case 2:
                                responseTasksOrdersServices = _context11.sent;

                                if (!responseTasksOrdersServices.ok) {
                                    _context11.next = 11;
                                    break;
                                }

                                _context11.next = 6;
                                return responseTasksOrdersServices.json();

                            case 6:
                                jsonTasksOrdersWithOutDestinations = _context11.sent;

                                localStorage.setItem("jsonGroupsServiceCopy", JSON.stringify(jsonTasksOrdersWithOutDestinations));
                                if (document.getElementById("layer2-btn").disabled === true) {
                                    document.getElementById("layer2-btn").disabled = false;
                                }

                                _context11.next = 12;
                                break;

                            case 11:
                                alert("HTTP-Error: " + responseTasksOrdersServices.status);

                            case 12:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function getTasksOrdersWithoutDestinations() {
                return _ref13.apply(this, arguments);
            }

            return getTasksOrdersWithoutDestinations;
        }()
    }, {
        key: 'getStateDestinations',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
                var responseDestinations, jsonTasksOrdersServices, i, j, k, layer, input, textToBeSearch;
                return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return fetch(this.state.urlApi + "TaskOrdersDestinationsStates", {
                                    headers: {
                                        'accessToken': this.props.accessToken
                                    }
                                });

                            case 2:
                                responseDestinations = _context12.sent;

                                if (!responseDestinations.ok) {
                                    _context12.next = 10;
                                    break;
                                }

                                _context12.next = 6;
                                return responseDestinations.json();

                            case 6:
                                realTimeDestinations = _context12.sent;

                                localStorage.setItem("jsonStateServiceRealTime", JSON.stringify(realTimeDestinations));

                                _context12.next = 11;
                                break;

                            case 10:
                                alert("HTTP-Error: " + responseDestinations.status);

                            case 11:
                                jsonTasksOrdersServices = localStorage.getItem("jsonGroupsService");

                                jsonTasksOrdersServices = JSON.parse(jsonTasksOrdersServices);
                                for (i = 0; i < jsonTasksOrdersServices.length; i++) {
                                    if (jsonTasksOrdersServices[i].destinationList !== null) {
                                        for (j = 0; j < jsonTasksOrdersServices[i].destinationList.length; j++) {
                                            for (k = 0; k < realTimeDestinations.length; k++) {
                                                if (jsonTasksOrdersServices[i].destinationList[j].id === realTimeDestinations[k].id) {
                                                    jsonTasksOrdersServices[i].destinationList[j] = {
                                                        descripcion: jsonTasksOrdersServices[i].destinationList[j].descripcion,
                                                        destinatario: jsonTasksOrdersServices[i].destinationList[j].destinatario,
                                                        direccionNoGeo: jsonTasksOrdersServices[i].destinationList[j].direccionNoGeo,
                                                        estadoDestino: jsonTasksOrdersServices[i].destinationList[j].estadoDestino,
                                                        horaEntregaEstimada: jsonTasksOrdersServices[i].destinationList[j].horaEntregaEstimada,
                                                        horaFinEntregaEstimada: jsonTasksOrdersServices[i].destinationList[j].horaFinEntregaEstimada,
                                                        id: jsonTasksOrdersServices[i].destinationList[j].id,
                                                        idServicio: jsonTasksOrdersServices[i].destinationList[j].idServicio,
                                                        idETipoEstadoTipoServicio: realTimeDestinations[k].idETipoEstadoTipoServicio,
                                                        idEstadoDestino: jsonTasksOrdersServices[i].destinationList[j].idEstadoDestino,
                                                        implicaCierreDestino: jsonTasksOrdersServices[i].destinationList[j].implicaCierreDestino,
                                                        latitud: jsonTasksOrdersServices[i].destinationList[j].latitud,
                                                        longitud: jsonTasksOrdersServices[i].destinationList[j].longitud,
                                                        productList: jsonTasksOrdersServices[i].destinationList[j].productList,
                                                        tfnoDestinatario: jsonTasksOrdersServices[i].destinationList[j].destinatario
                                                    };
                                                }
                                            }
                                        }
                                    }
                                }
                                localStorage.setItem("jsonGroupsService", JSON.stringify(jsonTasksOrdersServices));

                                layer = true;
                                input = document.getElementById("inputText");
                                textToBeSearch = "";

                                if (input !== null) textToBeSearch = input.value;

                                this.appliedMarkersDistributionFilter(this.state.valueDistributionSelect, textToBeSearch, layer);

                            case 20:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function getStateDestinations() {
                return _ref14.apply(this, arguments);
            }

            return getStateDestinations;
        }()
    }, {
        key: 'getAssetsTags',
        value: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
                var spinnerLoading, responseGroups, groups, i, element;
                return _regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                spinnerLoading = document.getElementById("spinnerLoading");

                                spinnerLoading.style.display = "block";
                                _context13.next = 4;
                                return fetch(this.state.urlApi + 'AssetsTags', {
                                    headers: {
                                        'accessToken': this.props.accessToken
                                    }
                                });

                            case 4:
                                responseGroups = _context13.sent;
                                groups = [];

                                if (!responseGroups.ok) {
                                    _context13.next = 14;
                                    break;
                                }

                                _context13.next = 9;
                                return responseGroups.json();

                            case 9:
                                jsonGroups = _context13.sent;


                                for (i = 0; i < jsonGroups.length; i++) {
                                    element = jsonGroups[i];

                                    element = {
                                        assetsTagInfo: jsonGroups[i].assetsTagInfo,
                                        assetsTagName: jsonGroups[i].assetsTagName,
                                        assetsTagsId: jsonGroups[i].assetsTagsId,
                                        isChecked: true
                                    };
                                    groups.push(element);
                                }
                                localStorage.setItem("jsonGroups", JSON.stringify(groups));

                                _context13.next = 15;
                                break;

                            case 14:
                                alert("HTTP-Error: " + responseGroups.status);

                            case 15:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function getAssetsTags() {
                return _ref15.apply(this, arguments);
            }

            return getAssetsTags;
        }()
    }, {
        key: 'getAssetsInfo',
        value: function () {
            var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
                var responseInfo, assetsInfo, i, element;
                return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return fetch(this.state.urlApi + 'AssetsInfo', {
                                    headers: {
                                        'accessToken': this.props.accessToken
                                    }
                                });

                            case 2:
                                responseInfo = _context14.sent;
                                assetsInfo = [];

                                if (!responseInfo.ok) {
                                    _context14.next = 12;
                                    break;
                                }

                                _context14.next = 7;
                                return responseInfo.json();

                            case 7:
                                jsonInfo = _context14.sent;

                                for (i = 0; i < jsonInfo.length; i++) {
                                    element = jsonInfo[i];

                                    element = {
                                        assetsIOTInfo: element.assetsIOTInfo,
                                        assetsInfoDriverName: element.assetsInfoDriverName,
                                        assetsInfoId: element.assetsInfoId,
                                        assetsInfoImei: element.assetsInfoImei,
                                        assetsInfoName: element.assetsInfoName,
                                        assetsInfoSerialNumber: element.assetsInfoSerialNumber,
                                        assetsTagsId: element.assetsTagsId,
                                        isChecked: true
                                    };
                                    assetsInfo.push(element);
                                }
                                localStorage.setItem("jsonInfo", JSON.stringify(assetsInfo));

                                _context14.next = 13;
                                break;

                            case 12:
                                window.location.replace("https://webapp.4gflota.com/#/ExpireKeyErr/");
                                // alert("HTTP-Error: " + responseInfo.status);

                            case 13:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function getAssetsInfo() {
                return _ref16.apply(this, arguments);
            }

            return getAssetsInfo;
        }()
    }, {
        key: 'getAssetsIOT',
        value: function () {
            var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(firstTime) {
                var t, jsonIOTempInfo, responseIOInfo, res, i, j, labelTemp, tag, result, data, _i3, _j, input, textToBeSearch;

                return _regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                t = this.props.t;
                                jsonIOTempInfo = "";
                                _context15.next = 4;
                                return fetch(this.state.urlApi + 'AssetsIOTInfo', {
                                    headers: {
                                        'accessToken': this.props.accessToken,
                                        'timestamp': firstTime
                                    }
                                });

                            case 4:
                                responseIOInfo = _context15.sent;

                                if (!responseIOInfo.ok) {
                                    _context15.next = 12;
                                    break;
                                }

                                _context15.next = 8;
                                return responseIOInfo.json();

                            case 8:
                                jsonIOTempInfo = _context15.sent;

                                if (!this.props.origin) {
                                    if (document.getElementById("layer1-btn").disabled === true) {
                                        document.getElementById("layer1-btn").disabled = false;
                                    }
                                }

                                _context15.next = 13;
                                break;

                            case 12:
                                // window.location.replace("https://webapp.4gflota.com/#/ExpireKeyErr/");
                                this.goToPageErr();

                            case 13:

                                jsonInfo = localStorage.getItem("jsonInfo");
                                jsonInfo = JSON.parse(jsonInfo);
                                res = "";

                                for (i = 0; i < jsonInfo.length; i++) {
                                    for (j = 0; j < jsonIOTempInfo.length; j++) {
                                        if (jsonInfo[i].assetsInfoImei === jsonIOTempInfo[j].assetsIOTImei.toString()) {
                                            labelTemp = "";
                                            tag = "";
                                            result = this.getBase4(jsonIOTempInfo[j].gOUTValue);

                                            res = this.adaptState(result);
                                            jsonIOTempInfo[j].gOUTValue = res;
                                            if (jsonIOTempInfo[j].tipoTrama === "ONM") {
                                                labelTemp = t("map.sidebar.filters.driving");
                                                tag = "Circulando";
                                            }
                                            if (jsonIOTempInfo[j].tipoTrama === "OFM") {
                                                labelTemp = t("map.sidebar.filters.driving");
                                                tag = "Circulando";
                                            }
                                            if (jsonIOTempInfo[j].tipoTrama === "ONS") {
                                                labelTemp = t("map.sidebar.filters.stop");
                                                tag = "Parado";
                                            }
                                            if (jsonIOTempInfo[j].tipoTrama === "OFS") {
                                                labelTemp = t("map.sidebar.filters.parked");
                                                tag = "Estacionado";
                                            }
                                            if (jsonIOTempInfo[j].tipoTrama === "OFGPRS") {
                                                labelTemp = t("map.sidebar.filters.noGprs");
                                                tag = "NoGprs";
                                            }
                                            if (jsonIOTempInfo[j].tipoTrama === "OFGPS") {
                                                labelTemp = "No-GPS";
                                                tag = "NoGps";
                                            }
                                            if (jsonIOTempInfo[j].tipoTrama === "OFINS") {
                                                labelTemp = "Pendiente de instalación";
                                                tag = "NoInstalacion";
                                            }

                                            jsonIOTempInfo[j] = {
                                                assetsInfoName: jsonInfo[i].assetsInfoName,
                                                assetsIOTImei: jsonIOTempInfo[j].assetsIOTImei,
                                                label: labelTemp,
                                                id: jsonInfo[i].assetsInfoId,
                                                tag: tag,

                                                gpsInfo: {
                                                    altitude: jsonIOTempInfo[j].gpsInfo.altitude,
                                                    angle: jsonIOTempInfo[j].gpsInfo.angle,
                                                    latitude: jsonIOTempInfo[j].gpsInfo.latitude,
                                                    longitude: jsonIOTempInfo[j].gpsInfo.longitude,
                                                    sattellites: jsonIOTempInfo[j].gpsInfo.satellites,
                                                    speed: jsonIOTempInfo[j].gpsInfo.speed,
                                                    timestamp: this.transformDate(jsonIOTempInfo[j].gpsInfo.timestamp),
                                                    timestampApi: jsonIOTempInfo[j].gpsInfo.timestamp
                                                },
                                                canInfo: {
                                                    odometro: jsonIOTempInfo[j].canInfo.odo,
                                                    fuelPorcentage: jsonIOTempInfo[j].canInfo.flp,
                                                    fuelLiters: jsonIOTempInfo[j].canInfo.fll
                                                },
                                                temperatura: {
                                                    temp: jsonIOTempInfo[j].temp
                                                },
                                                gOUTValue: jsonIOTempInfo[j].gOUTValue,
                                                tipoTrama: jsonIOTempInfo[j].tipoTrama
                                            };
                                        }
                                    }
                                }

                                if (!(firstTime === "0")) {
                                    _context15.next = 22;
                                    break;
                                }

                                jsonIOInfo = jsonIOTempInfo;
                                localStorage.setItem("jsonIOInfo", JSON.stringify(jsonIOInfo));
                                _context15.next = 34;
                                break;

                            case 22:
                                _context15.prev = 22;
                                _context15.next = 25;
                                return this.getDataFromIndexedDB();

                            case 25:
                                data = _context15.sent;

                                jsonIOInfo = data;
                                // Hacer algo con los datos recuperados
                                _context15.next = 32;
                                break;

                            case 29:
                                _context15.prev = 29;
                                _context15.t0 = _context15['catch'](22);

                                console.error('Error al obtener datos de IndexedDB:', _context15.t0);

                            case 32:

                                for (_i3 = 0; _i3 < jsonIOInfo.length; _i3++) {
                                    for (_j = 0; _j < jsonIOTempInfo.length; _j++) {
                                        if (jsonIOInfo[_i3].assetsIOTImei === jsonIOTempInfo[_j].assetsIOTImei) {
                                            jsonIOInfo[_i3] = jsonIOTempInfo[_j];
                                        }
                                    }
                                }

                                //localStorage.setItem("jsonIOInfo", JSON.stringify(jsonIOInfo));
                                this.saveJsonIOInfo(jsonIOInfo);

                            case 34:
                                input = document.getElementById("inputText");
                                textToBeSearch = "";

                                if (input !== null) {
                                    textToBeSearch = input.value;
                                }

                                this.appliedMarkersVFilter(this.state.value, textToBeSearch, this.state.checkBoxGroupIds);

                            case 38:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this, [[22, 29]]);
            }));

            function getAssetsIOT(_x11) {
                return _ref17.apply(this, arguments);
            }

            return getAssetsIOT;
        }()
    }, {
        key: 'getBase4',
        value: function getBase4(val) {
            var res = [0, 0, 0, 0];

            if (val <= 255) {
                if (val < 4) {
                    res[3] = val;
                } else {
                    var cociente = val;
                    var resAux = [0, 0, 0, 0];
                    var i = 0;

                    while (cociente >= 4) {
                        resAux[i] = cociente % 4;
                        cociente = Math.floor(cociente / 4);
                        i++;
                    }
                    resAux[i] = cociente;

                    switch (i) {
                        case 1:
                            res[2] = resAux[1];
                            res[3] = resAux[0];
                            break;
                        case 2:
                            res[1] = resAux[2];
                            res[2] = resAux[1];
                            res[3] = resAux[0];
                            break;
                        case 3:
                            res[0] = resAux[3];
                            res[1] = resAux[2];
                            res[2] = resAux[1];
                            res[3] = resAux[0];
                            break;
                    }
                }
            } else {
                res = [1, 1, 1, 1];
            }

            return res.reverse();
        }
    }, {
        key: 'appliedMarkersVFilter',
        value: function () {
            var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(newSelection, input, groupsIdsFilter) {
                var _this3 = this;

                var newArray, tmp, device, data, _loop, i, jsonTempInfo, j, jsonTempGroup, _i4, _j2, checkBoxGroupIdsTmp, result, markers, resultMakers, _j3, info, groupDevicesCopy, _resultMakers, newGroups, _i5, element, _result, _i6, _element3, _j4, element2, resu, res, spinnerLoading, tmp1;

                return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                newArray = [];
                                tmp = null;
                                device = [];
                                _context16.prev = 3;
                                _context16.next = 6;
                                return this.getDataFromIndexedDB();

                            case 6:
                                data = _context16.sent;

                                jsonIOInfo = data;
                                _context16.next = 13;
                                break;

                            case 10:
                                _context16.prev = 10;
                                _context16.t0 = _context16['catch'](3);

                                console.error('Error al obtener datos de IndexedDB:', _context16.t0);

                            case 13:

                                if (newSelection.length !== 0) {
                                    _loop = function _loop(i) {
                                        var selectOption = newSelection[i].tag;
                                        tmp = jsonIOInfo.filter(function (device) {
                                            return device.tag === selectOption;
                                        });
                                        if (newArray.length > 0) {
                                            newArray = newArray.concat(tmp);
                                        } else {
                                            newArray = tmp;
                                        }
                                    };

                                    for (i = 0; i < newSelection.length; i++) {
                                        _loop(i);
                                    }
                                } else {
                                    newArray = jsonIOInfo;
                                }

                                // Ordenar newArray por assetsInfoName
                                newArray.sort(function (a, b) {
                                    return (a.assetsInfoName || '').localeCompare(b.assetsInfoName || '');
                                });

                                newArray = newArray.filter(function (device) {
                                    return device.assetsInfoName !== undefined ? device.assetsInfoName.toLowerCase().match(input.toLowerCase()) : "";
                                });

                                jsonInfo = localStorage.getItem("jsonInfo");
                                jsonInfo = JSON.parse(jsonInfo);
                                jsonTempInfo = [];


                                for (i = 0; i < jsonInfo.length; i++) {
                                    for (j = 0; j < newArray.length; j++) {
                                        if (jsonInfo[i].assetsInfoImei === newArray[j].assetsIOTImei.toString()) {
                                            jsonInfo[i].assetsIOTInfo = [];
                                            jsonInfo[i].assetsIOTInfo.push(newArray[j]);
                                            jsonTempInfo.push(jsonInfo[i]);
                                        }
                                        if (jsonInfo[i].assetsInfoName === this.state.device.assetsInfoName) {
                                            device = jsonInfo[i];
                                        }
                                    }
                                }

                                // Ordenar jsonTempInfo por assetsInfoName
                                jsonTempInfo.sort(function (a, b) {
                                    return (a.assetsInfoName || '').localeCompare(b.assetsInfoName || '');
                                });

                                jsonGroups = localStorage.getItem("jsonGroups");
                                jsonGroups = JSON.parse(jsonGroups);
                                jsonTempGroup = [];


                                for (_i4 = 0; _i4 < jsonGroups.length; _i4++) {
                                    jsonGroups[_i4].assetsTagInfo = [];

                                    for (_j2 = 0; _j2 < jsonTempInfo.length; _j2++) {
                                        if (jsonGroups[_i4].assetsTagsId === jsonTempInfo[_j2].assetsTagsId) {
                                            jsonGroups[_i4].assetsTagInfo.push(jsonTempInfo[_j2]);
                                        }
                                    }

                                    if (jsonGroups[_i4].assetsTagInfo.length > 0) {
                                        // Ordenar assetsTagInfo dentro del grupo por assetsInfoName
                                        jsonGroups[_i4].assetsTagInfo.sort(function (a, b) {
                                            return (a.assetsInfoName || '').localeCompare(b.assetsInfoName || '');
                                        });
                                        jsonTempGroup.push(jsonGroups[_i4]);
                                    }
                                }

                                // Ordenar jsonTempGroup por assetsTagsName
                                jsonTempGroup.sort(function (a, b) {
                                    return (a.assetsTagName || '').localeCompare(b.assetsTagName || '');
                                });

                                checkBoxGroupIdsTmp = [].concat(_toConsumableArray(this.state.checkBoxGroupIds));
                                result = [];
                                markers = [];


                                if (checkBoxGroupIdsTmp.length > 0) {
                                    result = jsonTempInfo.filter(function (elem) {
                                        return !checkBoxGroupIdsTmp.find(function (value) {
                                            return elem.assetsTagsId == value;
                                        });
                                    });
                                    resultMakers = newArray.filter(function (elem) {
                                        return result.find(function (_ref19) {
                                            var assetsInfoName = _ref19.assetsInfoName;
                                            return elem.assetsInfoName == assetsInfoName;
                                        });
                                    });

                                    for (_j3 = 0; _j3 < resultMakers.length; _j3++) {
                                        info = resultMakers[_j3];

                                        markers.push(info);
                                    }
                                    newArray = markers;
                                }

                                groupDevicesCopy = [];

                                if (this.state.assetsInfoImeiArrFilter.length > 0) {
                                    _resultMakers = newArray.filter(function (elem) {
                                        return !_this3.state.assetsInfoImeiArrFilter.find(function (x) {
                                            return elem.assetsIOTImei == x.assetsInfoImei;
                                        });
                                    });

                                    newArray = _resultMakers;

                                    newGroups = [];

                                    for (_i5 = 0; _i5 < jsonTempGroup.length; _i5++) {
                                        element = jsonTempGroup[_i5];
                                        _result = element.assetsTagInfo.filter(function (elem2) {
                                            return _this3.state.assetsInfoImeiArrFilter.find(function (x) {
                                                return elem2.assetsInfoImei == x.assetsInfoImei;
                                            });
                                        });

                                        if (_result.length > 0) {
                                            groupDevicesCopy = jsonTempGroup;

                                            for (_i6 = 0; _i6 < jsonTempGroup.length; _i6++) {
                                                _element3 = jsonTempGroup[_i6];

                                                for (_j4 = 0; _j4 < _result.length; _j4++) {
                                                    element2 = _result[_j4];

                                                    element2.isChecked = false;
                                                    if (_element3.assetsTagsId == element2.assetsTagsId) {
                                                        _element3 = element2;
                                                    }
                                                    resu = this.getBase4(_result[_j4].gOUTValue);
                                                    res = this.adaptState(resu);

                                                    _result[_j4].gOUTValue = res;
                                                }
                                            }
                                        }
                                    }
                                }

                                if (this.state.isOpenDeviceContent) {
                                    this.followCenterDevice(jsonTempGroup, newArray, groupDevicesCopy, newSelection);
                                } else {
                                    spinnerLoading = document.getElementById("spinnerLoading");


                                    if (newArray.length === 0) {
                                        this.setState({
                                            center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
                                            options: Object.assign({}, this.state.options, { zoom: this.state.actualMap.zoom }),
                                            groupsDevices: groupDevicesCopy.length > 0 ? groupDevicesCopy : jsonTempGroup,
                                            markersV: newArray,
                                            device: device,
                                            popUpInfoDevice: false,
                                            value: newSelection,
                                            layerDevice: true
                                        }, function () {
                                            return spinnerLoading.style.display = "none";
                                        });
                                    } else {
                                        tmp1 = newArray.find(function (element) {
                                            return element.assetsIOTImei == _this3.state.device.assetsInfoImei;
                                        });

                                        if (tmp1 === undefined) {
                                            tmp1 = newArray.find(function (element) {
                                                return element.assetsIOTImei == _this3.state.device.assetsIOTImei;
                                            });
                                        }

                                        if (tmp1 !== undefined) {
                                            this.setState({
                                                center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
                                                options: Object.assign({}, this.state.options, { zoom: this.state.actualMap.zoom }),
                                                groupsDevices: groupDevicesCopy.length > 0 ? groupDevicesCopy : jsonTempGroup,
                                                markersV: newArray,
                                                device: device,
                                                value: newSelection,
                                                layerDevice: true
                                            }, function () {
                                                return spinnerLoading.style.display = "none";
                                            });
                                        } else {
                                            this.setState({
                                                center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
                                                options: Object.assign({}, this.state.options, { zoom: this.state.actualMap.zoom }),
                                                groupsDevices: groupDevicesCopy.length > 0 ? groupDevicesCopy : jsonTempGroup,
                                                markersV: newArray,
                                                device: device,
                                                popUpInfoDevice: false,
                                                value: newSelection,
                                                layerDevice: true
                                            }, function () {
                                                return spinnerLoading.style.display = "none";
                                            });
                                        }
                                    }
                                }

                            case 33:
                            case 'end':
                                return _context16.stop();
                        }
                    }
                }, _callee16, this, [[3, 10]]);
            }));

            function appliedMarkersVFilter(_x12, _x13, _x14) {
                return _ref18.apply(this, arguments);
            }

            return appliedMarkersVFilter;
        }()
    }, {
        key: 'handleOnChangeDistribution',
        value: function handleOnChangeDistribution(newSelection) {
            if (newSelection === null) newSelection = [];

            this.setState({
                valueDistributionSelect: newSelection
            });
            var input = document.getElementById("inputTextDistribution");
            var textToBeSearch = "";
            if (input !== null) textToBeSearch = input.value;
            this.appliedMarkersDistributionFilter(newSelection, textToBeSearch);
        }
    }, {
        key: 'appliedMarkersPoisFilter',
        value: function appliedMarkersPoisFilter(input) {

            var resultFilter = "";
            var jsonPoisGroups = localStorage.getItem("jsonGroupsPoisWithOutPois");
            jsonPoisGroups = JSON.parse(jsonPoisGroups);
            resultFilter = jsonPoisInfo.filter(function (poi) {
                return poi.cliente !== null ? poi.cliente.match(input) : "";
            });

            for (var i = 0; i < jsonPoisGroups.length; i++) {
                for (var j = 0; j < resultFilter.length; j++) {
                    if (resultFilter[j].idTipo === jsonPoisGroups[i].idTipo) {
                        jsonPoisGroups[i].poisInfo.push(resultFilter[j]);
                    }
                }
            }

            this.setState({
                groupsPois: jsonPoisGroups
            });
        }
    }, {
        key: 'appliedMarkersDistributionFilter',
        value: function () {
            var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(newSelection, input, distributionLayerIsOpen) {
                var newArrayTest, tmp, spinnerLoading, jsonGroupsServices, i, k, _selectOption, defaultJsonGroupsServices, _i7, j, _spinnerLoading3;

                return _regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                // console.log("appliedMarkersDistributionFilter")
                                newArrayTest = [];
                                tmp = null;


                                if (distributionLayerIsOpen) {
                                    spinnerLoading = document.getElementById("spinnerLoading");

                                    spinnerLoading.style.display = "none";
                                    this.setState({
                                        center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
                                        options: Object.assign({}, this.state.options, { zoom: this.state.actualMap.zoom }),
                                        groupsTasksServices: [],
                                        layerDistribution: !this.state.layerDistribution
                                    });
                                } else {
                                    jsonGroupsServices = localStorage.getItem("jsonGroupsService");

                                    jsonGroupsServices = JSON.parse(jsonGroupsServices);

                                    jsonTasksOrdersWithOutDestinations = localStorage.getItem("jsonGroupsServiceCopy");
                                    jsonTasksOrdersWithOutDestinations = JSON.parse(jsonTasksOrdersWithOutDestinations);

                                    if (newSelection.length > 0) {
                                        for (i = 0; i < jsonGroupsServices.length; i++) {
                                            for (k = 0; k < newSelection.length; k++) {
                                                _selectOption = newSelection[k].tag;

                                                if (_selectOption === "Finalizado") {
                                                    tmp = jsonGroupsServices[i].destinationList.filter(function (service) {
                                                        return service.idETipoEstadoTipoServicio === 2;
                                                    });

                                                    if (newArrayTest.length > 0) {
                                                        newArrayTest = newArrayTest.concat(tmp);
                                                    } else {
                                                        newArrayTest = tmp;
                                                    }
                                                }

                                                if (_selectOption === "En Proceso") {
                                                    tmp = jsonGroupsServices[i].destinationList.filter(function (service) {
                                                        return service.idETipoEstadoTipoServicio === 1;
                                                    });

                                                    if (newArrayTest.length > 0) {
                                                        newArrayTest = newArrayTest.concat(tmp);
                                                    } else {
                                                        newArrayTest = tmp;
                                                    }
                                                }
                                            }
                                        }
                                    } else {
                                        defaultJsonGroupsServices = localStorage.getItem("jsonGroupsService");

                                        defaultJsonGroupsServices = JSON.parse(defaultJsonGroupsServices);

                                        jsonTasksOrdersWithOutDestinations = defaultJsonGroupsServices;
                                    }

                                    for (_i7 = 0; _i7 < jsonTasksOrdersWithOutDestinations.length; _i7++) {
                                        for (j = 0; j < newArrayTest.length; j++) {
                                            if (jsonTasksOrdersWithOutDestinations[_i7].id === newArrayTest[j].idServicio) {
                                                jsonTasksOrdersWithOutDestinations[_i7].destinationList.push(newArrayTest[j]);
                                            }
                                        }
                                    }

                                    jsonTasksOrdersWithOutDestinations = jsonTasksOrdersWithOutDestinations.filter(function (v, i) {
                                        if (v["nombre"].match(input)) {
                                            return v["nombre"].match(input);
                                        } else {
                                            return v.idVehiculo1.match(input.toUpperCase());
                                        }

                                        // return ((v["nombre"].match(input)) && v.idVehiculo1.match(input));
                                    });
                                    // jsonTasksOrdersWithOutDestinations = jsonTasksOrdersWithOutDestinations.filter(service => service.nombre !== null ? service.nombre.match(input) : "")
                                    // if(jsonTasksOrdersWithOutDestinations.length <= 0) {
                                    //     console.log("entra");
                                    //     jsonTasksOrdersWithOutDestinations = jsonTasksOrdersWithOutDestinations.filter(service => service.idVehiculo1 !== null ? service.idVehiculo1.match(input) : "");
                                    // }
                                    _spinnerLoading3 = document.getElementById("spinnerLoading");

                                    _spinnerLoading3.style.display = "none";
                                    this.setState({
                                        center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
                                        options: Object.assign({}, this.state.options, { zoom: this.state.actualMap.zoom }),
                                        groupsTasksServices: jsonTasksOrdersWithOutDestinations,
                                        layerDistribution: true
                                    });
                                }

                            case 3:
                            case 'end':
                                return _context17.stop();
                        }
                    }
                }, _callee17, this);
            }));

            function appliedMarkersDistributionFilter(_x15, _x16, _x17) {
                return _ref20.apply(this, arguments);
            }

            return appliedMarkersDistributionFilter;
        }()
    }, {
        key: 'clearIntervalDevices',
        value: function clearIntervalDevices() {
            clearInterval(this.timerID);
        }
    }, {
        key: 'clearIntervalServices',
        value: function clearIntervalServices() {
            clearInterval(this.timerDestinations);
        }
    }, {
        key: 'handleClusteringEnd',
        value: function handleClusteringEnd(event) {

            // console.log("event");
            // console.log(event);
            var clusters = event.clusters;
            clusters.forEach(function (cluster) {
                if (cluster.markers.length === 1) {
                    var notClusteredMarker = cluster.markers[0];
                    if (!notClusteredMarker.getVisible()) notClusteredMarker.setVisible(true);
                    // console.log("visiibility=true")
                    //console.log("this.markersV")
                    //console.log(this.markersV)
                } else {
                    var ClusteredMarker = cluster.markers;
                    ClusteredMarker.forEach(function (marker) {
                        // console.log("visiibility=false")
                        // marker.hideMarkerContent();
                        //console.log(marker)
                        if (marker.getVisible()) marker.setVisible(false);
                    });
                }
            });
            // event.getMarkers().forEach((marker1) => {
            //     if (marker1.getVisible() === false && this.state.) {
            //         // console.log(marker1)
            //         marker1.visible = true
            //     }


            // })
        }
    }, {
        key: 'handleClusteringEnd1',
        value: function handleClusteringEnd1(event) {
            var _this4 = this;

            // console.log(this.state.actualMap.getBounds())
            // console.log(event.isMarkerInBounds);
            // event.getMarkers().forEach((marker1) => {
            //     if (marker1.getVisible()) {
            //         marker1.setVisible(false);
            //     }
            // })

            var clusters = event.clusters;

            clusters.forEach(function (cluster, i) {
                var notClusteredMarker = cluster.markers[0];

                if (cluster.markers.length === 1) {

                    if (notClusteredMarker.getVisible() === false) {
                        // console.log("entra");
                        notClusteredMarker.setVisible(true);
                    }
                } else {
                    var ClusteredMarker = cluster.markers;

                    ClusteredMarker.forEach(function (marker) {
                        if (_this4.state.actualMap.getZoom() >= 11) {
                            // console.log("entra2");
                            if (marker.getVisible() === false) {
                                marker.setVisible(true);
                            }
                            // if (this.state.actualMap.getBounds().contains(marker.getPosition())) {


                            // }
                        } else if (marker.getVisible()) {
                            // console.log("entra3");
                            marker.setVisible(false);
                        }
                    });
                }
            });
            // event.getMarkers().forEach((marker1) => {
            //     if (marker1.getVisible() === false && this.actualMap.getZoom() >= 11 && this.actualMap.getZoom() <= 12) {
            //         // console.log(marker1)
            //         marker1.visible = true
            //     }
            // })
            // console.log(event);


            if (this.state.actualMap.getZoom() >= 11 && this.state.count === 0) {

                this.setState({
                    center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
                    options: Object.assign({}, this.state.options, { zoom: this.state.actualMap.getZoom() }),
                    count: 1
                });
            }
            if (this.state.actualMap.getZoom() <= 9 && this.state.count === 1) {

                this.setState({
                    center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
                    options: Object.assign({}, this.state.options, { zoom: this.state.actualMap.getZoom() }),
                    count: 0
                });
            }

            // console.log(event.getMarkers());
        }
    }, {
        key: 'validateButton',
        value: function validateButton() {
            if (document.getElementById("layer3-btn").disabled === true) {
                document.getElementById("layer3-btn").disabled = false;
            }
        }

        // onKeyUpPois = (e) => {
        //     let input = document.getElementById("inputTextPois");
        //     let textToBeSearch = "";
        //     if (input !== null)
        //         textToBeSearch = input.value;
        //     this.appliedMarkersPoisFilter(textToBeSearch);
        // }

    }, {
        key: 'getAddress',
        value: function () {
            var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(lat, lng) {
                var address, response;
                return _regeneratorRuntime.wrap(function _callee18$(_context18) {
                    while (1) {
                        switch (_context18.prev = _context18.next) {
                            case 0:
                                if (!(lat !== 0)) {
                                    _context18.next = 14;
                                    break;
                                }

                                lat = lat.toString();
                                lng = lng.toString();

                                _context18.next = 5;
                                return fetch(this.state.urlApi + ('maps?lat=' + lat + '&lon=' + lng));

                            case 5:
                                address = _context18.sent;

                                if (!address.ok) {
                                    _context18.next = 13;
                                    break;
                                }

                                _context18.next = 9;
                                return address.text();

                            case 9:
                                response = _context18.sent;
                                return _context18.abrupt('return', response);

                            case 13:
                                alert("HTTP-Error: " + address.status);

                            case 14:
                            case 'end':
                                return _context18.stop();
                        }
                    }
                }, _callee18, this);
            }));

            function getAddress(_x18, _x19) {
                return _ref21.apply(this, arguments);
            }

            return getAddress;
        }()
    }, {
        key: 'handleOnClickMap',
        value: function () {
            var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(e) {
                var address, lat, lng, _address;

                return _regeneratorRuntime.wrap(function _callee19$(_context19) {
                    while (1) {
                        switch (_context19.prev = _context19.next) {
                            case 0:
                                if (!(this.state.optionsRoute.origin !== "")) {
                                    _context19.next = 8;
                                    break;
                                }

                                _context19.next = 3;
                                return this.getAddress(e.latLng.lat(), e.latLng.lng());

                            case 3:
                                address = _context19.sent;

                                // let latlng = new window.google.maps.LatLng(lat, lng);
                                this.setState({
                                    objWhenClickOnMap: {
                                        lat: e.latLng.lat(),
                                        lng: e.latLng.lng(),
                                        latView: 0,
                                        lngView: 0,
                                        address: address,
                                        visible: true,
                                        markerVisible: false,
                                        response: null,
                                        directionsRenderer: ""
                                    },

                                    optionsRoute: Object.assign({}, this.state.optionsRoute, {
                                        origin: this.state.optionsRoute.origin,
                                        destination: e.latLng
                                    }),
                                    markerPositionToDirectionRoute: Object.assign({}, this.state.markerPositionToDirectionRoute, {
                                        visible: false
                                    }),
                                    center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
                                    options: Object.assign({}, this.state.options, { zoom: this.state.actualMap.zoom })

                                });
                                return _context19.abrupt('return');

                            case 8:
                                if (!(this.state.objWhenClickOnMap.visible && this.state.objWhenClickOnMap.markerVisible)) {
                                    _context19.next = 12;
                                    break;
                                }

                                this.setState({
                                    objWhenClickOnMap: {
                                        lat: 0,
                                        lng: 0,
                                        latView: 0,
                                        lngView: 0,
                                        address: "",
                                        visible: false,
                                        markerVisible: false,
                                        response: null,
                                        directionsRenderer: "",
                                        latLng: ''

                                    },
                                    center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
                                    options: Object.assign({}, this.state.options, { zoom: this.state.actualMap.zoom })

                                });
                                _context19.next = 18;
                                break;

                            case 12:
                                lat = e.latLng.lat();
                                lng = e.latLng.lng();
                                _context19.next = 16;
                                return this.getAddress(lat, lng);

                            case 16:
                                _address = _context19.sent;

                                this.setState({
                                    objWhenClickOnMap: {
                                        lat: lat,
                                        lng: lng,
                                        latView: this.calc(lat),
                                        lngView: this.calc(lng),
                                        address: _address,
                                        visible: true,
                                        markerVisible: true,
                                        response: null,
                                        directionsRenderer: "",
                                        latLng: e.latLng

                                    },
                                    center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
                                    options: Object.assign({}, this.state.options, { zoom: this.state.actualMap.zoom })

                                });

                            case 18:
                            case 'end':
                                return _context19.stop();
                        }
                    }
                }, _callee19, this);
            }));

            function handleOnClickMap(_x20) {
                return _ref22.apply(this, arguments);
            }

            return handleOnClickMap;
        }()
    }, {
        key: 'copyToClipboardAndCreateUrl',
        value: function copyToClipboardAndCreateUrl() {
            var _this5 = this;

            navigator.clipboard.writeText('https://www.google.com/maps/search/?api=1&query=' + this.state.objWhenClickOnMap.lat + ',' + this.state.objWhenClickOnMap.lng);
            this.setState({
                isOpenTooltip: true,
                center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() }
            }, function () {
                setTimeout(function () {
                    _this5.setState({
                        isOpenTooltip: false,
                        center: { lat: _this5.state.actualMap.center.lat(), lng: _this5.state.actualMap.center.lng() }
                    });
                }, 2000);
            });
        }
    }, {
        key: 'copyToClipboardAndCreateUrlDirections',
        value: function copyToClipboardAndCreateUrlDirections() {
            var _this6 = this;

            var arrayWaypoints = "";
            if (this.state.directionsRenderer.directions.request.waypoints !== undefined) {
                if (this.state.directionsRenderer.directions.request.waypoints.length > 0) {
                    for (var i = 0; i < this.state.directionsRenderer.directions.request.waypoints.length; i++) {
                        var element = this.state.directionsRenderer.directions.request.waypoints[i];
                        // arrayWaypoints.push(element.location.lat() + "," + element.location.lng())
                        arrayWaypoints += element.location.lat() + "," + element.location.lng() + "|";
                    }
                }
            }

            navigator.clipboard.writeText('https://www.google.com/maps/dir/?api=1&origin=' + this.state.directionsRenderer.directions.routes[0].legs[0].start_location.lat() + ',' + this.state.directionsRenderer.directions.routes[0].legs[0].start_location.lng() + '&destination=' + this.state.directionsRenderer.directions.routes[0].legs[0].end_location.lat() + ',' + this.state.directionsRenderer.directions.routes[0].legs[0].end_location.lng() + '&travelmode=driving&waypoints=' + arrayWaypoints);
            this.setState({
                isOpenTooltip: true,
                center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() }
            }, function () {
                setTimeout(function () {
                    _this6.setState({
                        isOpenTooltip: false,
                        center: { lat: _this6.state.actualMap.center.lat(), lng: _this6.state.actualMap.center.lng() }
                    });
                }, 2000);
            });
        }
    }, {
        key: 'calc',
        value: function calc(num) {
            var with6Decimals = num.toString().match(/^-?\d+(?:\.\d{0,6})?/)[0];
            return with6Decimals;
        }
    }, {
        key: 'directionsCallback',
        value: function directionsCallback(response) {
            // console.log(response);
            if (this.state.response !== null) {
                return;
            } else {
                if (response !== null) {
                    if (response.status === 'OK') {
                        this.setState({
                            response: response,
                            center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
                            options: Object.assign({}, this.state.options, { zoom: this.state.actualMap.zoom })
                            // () => ({
                            //     response
                            // })
                        });
                    } else {
                        console.log('response: ', response);
                    }
                }
            }
        }
    }, {
        key: 'handleOnClickStartHowToGet',
        value: function handleOnClickStartHowToGet() {
            this.setState({
                optionsRoute: Object.assign({}, this.state.optionsRoute, {
                    origin: this.state.objWhenClickOnMap.latLng

                }),
                objWhenClickOnMap: Object.assign({}, this.state.objWhenClickOnMap, {
                    markerVisible: false,
                    visible: false
                }),
                markerPositionToDirectionRoute: {
                    lat: this.state.objWhenClickOnMap.lat,
                    lng: this.state.objWhenClickOnMap.lng,
                    visible: true
                },
                center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
                options: Object.assign({}, this.state.options, { zoom: this.state.actualMap.zoom })
            });
        }
    }, {
        key: 'handleOnClickClosePopUpDirection',
        value: function handleOnClickClosePopUpDirection() {
            var _setState;

            this.setState((_setState = {
                objWhenClickOnMap: Object.assign({}, this.state.objWhenClickOnMap, {
                    markerVisible: false,
                    visible: false
                }),
                markerPositionToDirectionRoute: Object.assign({}, this.state.markerPositionToDirectionRoute, {
                    visible: false
                }),
                response: null,
                optionsRoute: {
                    destination: "",
                    origin: "",
                    travelMode: "DRIVING"
                },
                directionsRenderer: ""
            }, _defineProperty(_setState, 'objWhenClickOnMap', {
                lat: 0,
                lng: 0,
                latView: 0,
                lngView: 0,
                address: "",
                visible: false,
                markerVisible: false
            }), _defineProperty(_setState, 'center', { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() }), _defineProperty(_setState, 'options', Object.assign({}, this.state.options, { zoom: this.state.actualMap.zoom })), _setState));
        }
    }, {
        key: 'isEmpty',
        value: function isEmpty(obj) {
            for (var prop in obj) {
                if (obj.hasOwnProperty("query")) {
                    return true;
                } else {
                    return false;
                }
            }

            // return JSON.stringify(obj) === JSON.stringify({});
        }
    }, {
        key: 'inIframe',
        value: function inIframe() {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        }
    }, {
        key: 'filterCheckboxGroup',
        value: function () {
            var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(id, jsonGroups, newSelection) {
                var checkBoxGroupIdsTmp, newArray, tmp, i, _selectOption2, jsonIOInfoTmp, data, _jsonIOInfoTmp, _data, jsonInfoTmp, result, arr, _loop2, _i8, spinnerLoading, _data2;

                return _regeneratorRuntime.wrap(function _callee20$(_context20) {
                    while (1) {
                        switch (_context20.prev = _context20.next) {
                            case 0:

                                jsonIOInfo = this.state.markersV;

                                jsonInfo = localStorage.getItem("jsonInfo");
                                jsonInfo = JSON.parse(jsonInfo);
                                //console.log(jsonInfo);

                                checkBoxGroupIdsTmp = [].concat(_toConsumableArray(this.state.checkBoxGroupIds));

                                if (id != null && this.state.checkBoxGroupIds.length > 0) {
                                    //console.log(checkBoxGroupIdsTmp.find(x => x != id));
                                    if (checkBoxGroupIdsTmp.find(function (x) {
                                        return x != id;
                                    })) {
                                        checkBoxGroupIdsTmp.push(id);
                                    }
                                } else {
                                    if (id != null) {
                                        checkBoxGroupIdsTmp.push(id);
                                    }
                                }
                                //checkBoxGroupIdsTmp.push(id);
                                newArray = [];
                                tmp = null;

                                if (!(newSelection != null)) {
                                    _context20.next = 26;
                                    break;
                                }

                                if (!(newSelection.length !== 0)) {
                                    _context20.next = 12;
                                    break;
                                }

                                for (i = 0; i < newSelection.length; i++) {
                                    _selectOption2 = newSelection[i].tag;

                                    if (_selectOption2 === "Circulando") {
                                        tmp = jsonIOInfo.filter(function (device) {
                                            return device.tag === "Circulando";
                                        });
                                        if (newArray.length > 0) {
                                            newArray = newArray.concat(tmp);
                                        } else {
                                            newArray = tmp;
                                        }
                                    }
                                    if (_selectOption2 === "Parado") {

                                        tmp = jsonIOInfo.filter(function (device) {
                                            return device.tag === "Parado";
                                        });

                                        if (newArray.length > 0) {
                                            newArray = newArray.concat(tmp);
                                        } else {
                                            newArray = tmp;
                                        }
                                    }
                                    if (_selectOption2 === "Estacionado") {

                                        tmp = jsonIOInfo.filter(function (device) {
                                            return device.tag === "Estacionado";
                                        });
                                        if (newArray.length > 0) {
                                            newArray = newArray.concat(tmp);
                                        } else {
                                            newArray = tmp;
                                        }
                                    }
                                    if (_selectOption2 === "NoGprs") {

                                        tmp = jsonIOInfo.filter(function (device) {
                                            return device.tag === "NoGprs";
                                        });
                                        if (newArray.length > 0) {
                                            newArray = newArray.concat(tmp);
                                        } else {
                                            newArray = tmp;
                                        }
                                    }
                                }
                                _context20.next = 24;
                                break;

                            case 12:

                                //let jsonIOInfoTmp = localStorage.getItem("jsonIOInfo");
                                //jsonIOInfoTmp = JSON.parse(jsonIOInfoTmp);
                                jsonIOInfoTmp = "";
                                _context20.prev = 13;
                                _context20.next = 16;
                                return this.getDataFromIndexedDB();

                            case 16:
                                data = _context20.sent;

                                jsonIOInfoTmp = data;
                                // Hacer algo con los datos recuperados
                                _context20.next = 23;
                                break;

                            case 20:
                                _context20.prev = 20;
                                _context20.t0 = _context20['catch'](13);

                                console.error('Error al obtener datos de IndexedDB:', _context20.t0);

                            case 23:

                                newArray = jsonIOInfoTmp;

                            case 24:
                                _context20.next = 38;
                                break;

                            case 26:
                                _jsonIOInfoTmp = "";
                                _context20.prev = 27;
                                _context20.next = 30;
                                return this.getDataFromIndexedDB();

                            case 30:
                                _data = _context20.sent;


                                _jsonIOInfoTmp = _data;
                                // Hacer algo con los datos recuperados
                                _context20.next = 37;
                                break;

                            case 34:
                                _context20.prev = 34;
                                _context20.t1 = _context20['catch'](27);

                                console.error('Error al obtener datos de IndexedDB:', _context20.t1);

                            case 37:
                                // let jsonIOInfoTmp = localStorage.getItem("jsonIOInfo");
                                // jsonIOInfoTmp = JSON.parse(jsonIOInfoTmp);
                                newArray = _jsonIOInfoTmp;

                            case 38:
                                jsonInfoTmp = jsonInfo;
                                result = [];
                                arr = [];

                                if (checkBoxGroupIdsTmp.length > 0) {
                                    _loop2 = function _loop2(_i8) {
                                        var test = [];
                                        var element = checkBoxGroupIdsTmp[_i8];

                                        result = jsonInfoTmp.filter(function (x) {
                                            return x.assetsTagsId != element;
                                        });
                                        //console.log(result);
                                        jsonInfoTmp = result;
                                        if (newArray.length > 0) {
                                            jsonIOInfo = newArray;
                                        }
                                        var r = jsonIOInfo.filter(function (elem) {
                                            return result.find(function (_ref24) {
                                                var assetsInfoImei = _ref24.assetsInfoImei;
                                                return elem.assetsIOTImei == assetsInfoImei;
                                            });
                                        });

                                        for (var j = 0; j < r.length; j++) {
                                            var info = r[j];

                                            test.push(info);
                                        }
                                        arr = test;
                                    };

                                    for (_i8 = 0; _i8 < checkBoxGroupIdsTmp.length; _i8++) {
                                        _loop2(_i8);
                                    }
                                }

                                //console.log(arr);

                                // let result = jsonInfo.filter(x => x.assetsTagsId == id);
                                spinnerLoading = document.getElementById("spinnerLoading");
                                // const r = jsonIOInfo.filter((elem) => !result.find(({ assetsInfoImei }) => elem.assetsIOTImei == assetsInfoImei));
                                // console.log(r);

                                if (!(checkBoxGroupIdsTmp.length == 0)) {
                                    _context20.next = 57;
                                    break;
                                }

                                _context20.prev = 44;
                                _context20.next = 47;
                                return this.getDataFromIndexedDB();

                            case 47:
                                _data2 = _context20.sent;

                                jsonIOInfo = _data2;
                                // Hacer algo con los datos recuperados
                                _context20.next = 54;
                                break;

                            case 51:
                                _context20.prev = 51;
                                _context20.t2 = _context20['catch'](44);

                                console.error('Error al obtener datos de IndexedDB:', _context20.t2);

                            case 54:
                                // jsonIOInfo = localStorage.getItem("jsonIOInfo");
                                // jsonIOInfo = JSON.parse(jsonIOInfo);
                                this.setState({
                                    center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
                                    options: Object.assign({}, this.state.options, { zoom: this.state.actualMap.zoom }),
                                    //groupsDevices: jsonGroups,
                                    markersV: jsonIOInfo,
                                    // device: device,
                                    //*popUpInfoDevice: false,
                                    checkBoxGroupIds: checkBoxGroupIdsTmp,
                                    //value: newSelection,
                                    layerDevice: true
                                }, function () {
                                    spinnerLoading.style.display = "none";
                                    //console.log(this.state.groupsDevices);
                                });
                                _context20.next = 58;
                                break;

                            case 57:
                                this.setState({
                                    center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
                                    options: Object.assign({}, this.state.options, { zoom: this.state.actualMap.zoom }),
                                    //groupsDevices: jsonGroups,
                                    markersV: arr,
                                    // device: device,
                                    //*popUpInfoDevice: false,
                                    checkBoxGroupIds: checkBoxGroupIdsTmp,
                                    //value: newSelection,
                                    layerDevice: true
                                }, function () {
                                    spinnerLoading.style.display = "none";
                                    //console.log(this.state.groupsDevices);
                                });

                            case 58:
                            case 'end':
                                return _context20.stop();
                        }
                    }
                }, _callee20, this, [[13, 20], [27, 34], [44, 51]]);
            }));

            function filterCheckboxGroup(_x21, _x22, _x23) {
                return _ref23.apply(this, arguments);
            }

            return filterCheckboxGroup;
        }()

        // Obtener las regiones seleccionadas de los grupos anteriores


        // handleBorrarFiltro = () => {
        //     // Restablecer el filtro, mostrando todas las opciones originales
        //     const { originalGroupRegions } = this.state;
        //     this.setState({
        //         groupRegions: originalGroupRegions,
        //         searchText: '',
        //         center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
        //         options: { ...this.state.options, zoom: this.state.actualMap.zoom },
        //     });
        // };

    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            var t = this.props.t;

            console.error = function () {};

            return React.createElement(
                GoogleMap,
                {
                    mapContainerClassName: 'google_map',
                    id: 'google_map',
                    ref: this.mapRef,
                    mapContainerStyle: {
                        height: "100%",
                        width: "100%",
                        top: "0px; left: 0px",
                        backgroundColor: "rgb(229, 227, 223)",
                        marginLeft: "0px",
                        position: "relative",
                        overflow: "hidden"
                    },
                    onClick: this.handleOnClickMap.bind(this),
                    onLoad: function onLoad(map) {
                        _this7.actualMap = map;

                        document.getElementById("pin").style.display = "none";
                        _this7.setState({
                            actualMap: map

                        });
                        _this7.timerID = setInterval(function () {
                            _this7.getAssetsIOT("1");
                        }, 10000);
                    },
                    options: this.state.options,
                    zoom: this.state.options.zoom
                    // zoom={17}
                    , center: {
                        lat: this.state.center.lat,
                        lng: this.state.center.lng
                        // lat: 27.858446,
                        // lng: -15.429540
                    }
                },
                this.state.groupRegions.length > 0 && this.state.groupRegions.map(function (tipoRegion) {
                    return (
                        //tipoRegion.isChecked &&
                        tipoRegion.regiones.map(function (region) {
                            return region.isChecked && React.createElement(Polygon, {
                                key: region.idRegion,
                                path: region.vertices.map(function (vertice) {
                                    return { lat: vertice.latitud, lng: vertice.longitud };
                                }),
                                options: {
                                    fillColor: '#' + tipoRegion.color.toString(16),
                                    fillOpacity: 0.6,
                                    strokeColor: '#' + tipoRegion.borde.toString(16),
                                    strokeOpacity: 1,
                                    strokeWeight: tipoRegion.ancho
                                }
                                //onClick={() => this.handleRegionClick(tipoRegion.idTipoRegion, region.idRegion)} // Nuevo
                            });
                        })
                    );
                }),
                React.createElement('div', { id: 'spinnerLoading', className: 'sp sp-3balls', style: { marginLeft: "168px", display: "none" } }),
                this.state.isInIframe === false ? React.createElement(
                    BottomData,
                    {
                        filterForGroups: this.filterForGroups,
                        permisionPois: this.state.permisionPois,
                        permisionDistribution: this.state.permisionDistribution,
                        permisionRegiones: this.state.permisionRegiones,
                        permisionActivator: this.state.permisionActivator,
                        getPoisInfo: this.getPoisInfo,
                        getPoisData: this.getPoisData,
                        centerMapWihtOutFollow: this.centerMapWihtOutFollow,
                        isOpenDeviceContent: this.state.isOpenDeviceContent,
                        centerDevice: this.state.centerDevice.assetsIOTImei,
                        setLatLng: this.setLatLng,
                        getTaskOrdersLayerFunc: this.getTaskOrdersLayerFunc,
                        groupsTasksServicesList: this.state.groupsTasksServices,
                        layerDistributionFunc: this.layerDistributionFunc,
                        layerPoisFunc: this.layerPoisFunc,
                        layerDeviceFunc: this.layerDeviceFunc,
                        layerDevice: this.state.layerDevice,
                        centerMap: this.centerMap,
                        groupsPois: this.state.groupsPois,
                        groupsDevicesList: this.state.groupsDevices,
                        realTimeDevices: this.state.markersV,
                        valueFilter: this.state.value,
                        layerDistribution: this.state.layerDistribution,
                        layerPois: this.state.layerPois,
                        layerRegions: this.state.layerRegions,
                        transformDateAndCompare: this.transformDateAndCompare,
                        filterForDevice: this.filterForDevice,
                        handleCheckboxPoisChange: this.handleCheckboxPoisChange,
                        handleCheckboxPoiChange: this.handleCheckboxPoiChange,
                        layerRegionsFunc: this.layerRegionsFunc,
                        groupRegions: this.state.groupRegions,
                        handleCheckboxRegionsChange: this.handleCheckboxRegionsChange,
                        handleCheckboxRegionChange: this.handleCheckboxRegionChange,
                        accessToken: this.props.accessToken

                    },
                    React.createElement(
                        'div',
                        { className: 'map-search-wrap clearfix' },
                        React.createElement(
                            'div',
                            { className: 'map-search-left' },
                            React.createElement(
                                'div',
                                { className: 'input-group' },
                                React.createElement('input', { id: 'inputText', onChange: this.onKeyUp, name: 'valueSearchFilter', type: 'text', className: 'form-control input-md' }),
                                React.createElement(
                                    'span',
                                    { className: 'input-group-btn' },
                                    React.createElement(
                                        'button',
                                        { className: 'btn btn-lg', type: 'button' },
                                        React.createElement('img', { src: 'https://staticcontent.inelcan.com/img/search_grey.svg', alt: '' })
                                    )
                                )
                            )
                        )
                    ),
                    React.createElement(Select, {
                        value: this.state.value,
                        onChange: this.handleOnChange.bind(this),
                        isMulti: true,
                        name: 'colors',
                        options: this.state.optionsFiltersDevices,
                        className: 'basic-multi-select',
                        classNamePrefix: 'select',
                        style: { width: "30%" },
                        showNewOptionAtTop: false,
                        placeholder: t("map.sidebar.filterSelectInput.selectState")
                    }),
                    React.createElement(
                        'div',
                        { className: 'map-search-wrap clearfix' },
                        React.createElement(
                            'div',
                            { className: 'map-search-left' },
                            React.createElement(
                                'div',
                                { className: 'input-group' },
                                React.createElement('input', { id: 'inputTextDistribution', onChange: this.onKeyUpServices, name: 'valueSearchFilter', type: 'text', className: 'form-control input-md' }),
                                React.createElement(
                                    'span',
                                    { className: 'input-group-btn' },
                                    React.createElement(
                                        'button',
                                        { className: 'btn btn-lg', type: 'button' },
                                        React.createElement('img', { src: 'https://staticcontent.inelcan.com/img/search_grey.svg', alt: '' })
                                    )
                                )
                            )
                        )
                    ),
                    React.createElement(Select, {
                        value: this.state.valueDistributionSelect,
                        onChange: this.handleOnChangeDistribution.bind(this),
                        isMulti: true,
                        name: 'colors',
                        options: this.state.optionsDistribution,
                        className: 'basic-multi-select',
                        classNamePrefix: 'select',
                        style: { width: "30%" },
                        showNewOptionAtTop: false,
                        placeholder: t("map.sidebar.filterSelectInput.selectState")
                    }),
                    React.createElement(
                        'div',
                        { className: 'map-search-wrap clearfix' },
                        React.createElement(
                            'div',
                            { className: 'map-search-left' },
                            React.createElement(
                                'div',
                                { className: 'input-group' },
                                React.createElement('input', { id: 'inputTextPois', onChange: this.onKeyUpPois, name: 'valueSearchFilter', type: 'text', className: 'form-control input-md' }),
                                React.createElement(
                                    'span',
                                    { className: 'input-group-btn' },
                                    React.createElement(
                                        'button',
                                        { className: 'btn btn-lg', type: 'button' },
                                        React.createElement('img', { src: 'https://staticcontent.inelcan.com/img/search_grey.svg', alt: '' })
                                    )
                                )
                            )
                        )
                    ),
                    React.createElement(Select, {
                        value: this.state.valueSelectPois,
                        onChange: this.handleOnChangeSelectPois.bind(this),
                        name: 'colors',
                        options: this.state.optionsFilterSelectRegiones,
                        className: 'basic-multi-select',
                        classNamePrefix: 'select',
                        style: { width: "30%" },
                        showNewOptionAtTop: false,
                        placeholder: "Seleccionar visualización"
                    }),
                    React.createElement(
                        'div',
                        { className: 'map-search-wrap clearfix' },
                        React.createElement(
                            'div',
                            { className: 'map-search-left' },
                            React.createElement(
                                'div',
                                { className: 'input-group' },
                                React.createElement('input', { id: 'inputTextRegions', onChange: this.handleSearchTextRegionsChange, name: 'valueSearchFilter', type: 'text', className: 'form-control input-md' }),
                                React.createElement(
                                    'span',
                                    { className: 'input-group-btn' },
                                    React.createElement(
                                        'button',
                                        { className: 'btn btn-lg', type: 'button' },
                                        React.createElement('img', { src: 'https://staticcontent.inelcan.com/img/search_grey.svg', alt: '' })
                                    )
                                )
                            )
                        )
                    ),
                    React.createElement(Select, {
                        value: this.state.valueSelectRegiones,
                        onChange: this.handleOnChangeSelectRegions.bind(this),
                        name: 'colors',
                        options: this.state.optionsFilterSelectRegiones,
                        className: 'basic-multi-select',
                        classNamePrefix: 'select',
                        style: { width: "30%" },
                        showNewOptionAtTop: false,
                        placeholder: "Seleccionar visualización"
                    })
                ) : null,
                React.createElement(IconOptionsMap, {
                    profiles: this.props.profiles,
                    value: this.props.value,
                    map: this.state,
                    actualMap: this.state.actualMap,
                    trafficLayerShow: this.trafficLayerShow,
                    mapMobile: this.mapMobile,
                    viewSatelliteMap: this.viewSatelliteMap,
                    viewStandardMap: this.viewStandardMap,
                    toggleUi: this.toggleUi,
                    centerMap: this.centerMap,
                    chargeProfile: this.chargeProfile,
                    email: this.props.userDataInfo.email !== undefined ? this.props.userDataInfo.email : this.props.emailToProfile,
                    changeGroupMarkerVehicle: this.changeGroupMarkerVehicle
                }),


                /*this.state.markersV.length <= 60 && this.state.markersV.length > 5 ?
                    <MarkerClusterer
                        options={{ imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m" }}
                        onClusteringEnd={this.handleClusteringEnd1.bind(this)}
                        maxZoom={10}
                        gridSize={45}
                    >
                        {
                            (clusterer) => this.state.markersV.map((location, i) => (
                                <MarkerV
                                    key={i}
                                    position={{ lat: location.gpsInfo.latitude, lng: location.gpsInfo.longitude }}
                                    clusterer={clusterer}
                                    name={location.assetsInfoName}
                                    speed={location.gpsInfo.speed}
                                    angle={location.gpsInfo.angle}
                                    device={location}
                                    handleOnClick={this.handleOnClick}
                                    urlApi={this.state.urlApi}
                                    accessToken={this.state.accessToken}
                                    createMarkerHistoricalStopsIndividually={this.createMarkerHistoricalStopsIndividually}
                                    centerMapWihtOutFollow={this.centerMapWihtOutFollow} isOpenDeviceContent={this.state.isOpenDeviceContent} centerDevice={this.state.centerDevice.assetsIOTImei} setLatLng={this.setLatLng} getTaskOrdersLayerFunc={this.getTaskOrdersLayerFunc} groupsTasksServicesList={this.state.groupsTasksServices} layerDistributionFunc={this.layerDistributionFunc} layerDeviceFunc={this.layerDeviceFunc} layerDevice={this.state.layerDevice} centerMap={this.centerMap} groupsDevicesList={this.state.groupsDevices} realTimeDevices={this.state.markersV}
                                    closePopUpDeviceInfo={this.closePopUpDeviceInfo}
                                    actualMap={this.actualMap}
                                    actualZoom={this.state.actualZoom}
                                    markersDisplay={this.state.markersDisplay}
                                    isShown={this.state.isShown}
                                    transformDateAndCompare={this.transformDateAndCompare}
                                >
                                 </MarkerV>
                              ))
                        }
                    </MarkerClusterer>
                    :
                    <MarkerClusterer
                        options={{ imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m" }}
                        onClusteringEnd={this.handleClusteringEnd.bind(this)}
                    >
                        {
                            (clusterer) => this.state.markersV.map((location, i) => (
                                <MarkerV2
                                    key={i}
                                    position={{ lat: location.gpsInfo !== null ? location.gpsInfo.latitude : 0, lng: location.gpsInfo !== null ? location.gpsInfo.longitude : 0 }}
                                    clusterer={clusterer}
                                    name={location.assetsInfoName}
                                    speed={location.gpsInfo !== null ? location.gpsInfo.speed : 0}
                                    angle={location.gpsInfo !== null ? location.gpsInfo.angle : 0}
                                    device={location}
                                    handleOnClick={this.handleOnClick}
                                    urlApi={this.state.urlApi}
                                    accessToken={this.state.accessToken}
                                    createMarkerHistoricalStopsIndividually={this.createMarkerHistoricalStopsIndividually}
                                    centerMapWihtOutFollow={this.centerMapWihtOutFollow} isOpenDeviceContent={this.state.isOpenDeviceContent} centerDevice={this.state.centerDevice.assetsIOTImei} setLatLng={this.setLatLng} getTaskOrdersLayerFunc={this.getTaskOrdersLayerFunc} groupsTasksServicesList={this.state.groupsTasksServices} layerDistributionFunc={this.layerDistributionFunc} layerDeviceFunc={this.layerDeviceFunc} layerDevice={this.state.layerDevice} centerMap={this.centerMap} groupsDevicesList={this.state.groupsDevices} realTimeDevices={this.state.markersV}
                                    closePopUpDeviceInfo={this.closePopUpDeviceInfo}
                                    actualMap={this.actualMap}
                                    actualZoom={this.state.actualZoom}
                                    transformDateAndCompare={this.transformDateAndCompare}
                                >
                                 </MarkerV2>
                               ))
                        }
                     </MarkerClusterer>*/
                this.state.markersV.length > 0 && this.state.isVehicleGrouped ? React.createElement(
                    MarkerClusterer,
                    {
                        options: { imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m" },
                        onClusteringEnd: this.handleClusteringEnd.bind(this)
                    },
                    function (clusterer) {
                        return _this7.state.markersV.map(function (location, i) {
                            return React.createElement(MarkerV2, {
                                key: i,
                                position: { lat: location.gpsInfo !== null ? location.gpsInfo.latitude : 0, lng: location.gpsInfo !== null ? location.gpsInfo.longitude : 0 },
                                clusterer: clusterer,
                                name: location.assetsInfoName,
                                speed: location.gpsInfo !== null ? location.gpsInfo.speed : 0,
                                angle: location.gpsInfo !== null ? location.gpsInfo.angle : 0,
                                device: location,
                                handleOnClick: _this7.handleOnClick,
                                urlApi: _this7.state.urlApi,
                                accessToken: _this7.state.accessToken,
                                createMarkerHistoricalStopsIndividually: _this7.createMarkerHistoricalStopsIndividually,
                                centerMapWihtOutFollow: _this7.centerMapWihtOutFollow,
                                isOpenDeviceContent: _this7.state.isOpenDeviceContent,
                                centerDevice: _this7.state.centerDevice.assetsIOTImei,
                                setLatLng: _this7.setLatLng,
                                getTaskOrdersLayerFunc: _this7.getTaskOrdersLayerFunc,
                                groupsTasksServicesList: _this7.state.groupsTasksServices,
                                layerDistributionFunc: _this7.layerDistributionFunc,
                                layerDeviceFunc: _this7.layerDeviceFunc,
                                layerDevice: _this7.state.layerDevice,
                                centerMap: _this7.centerMap,
                                groupsDevicesList: _this7.state.groupsDevices,
                                realTimeDevices: _this7.state.markersV,
                                closePopUpDeviceInfo: _this7.closePopUpDeviceInfo,
                                actualMap: _this7.actualMap,
                                actualZoom: _this7.state.actualZoom,
                                transformDateAndCompare: _this7.transformDateAndCompare,
                                tag: location.tag,
                                isVehicleGrouped: _this7.state.isVehicleGrouped
                            });
                        });
                    }
                ) : this.state.markersV.map(function (location, i) {
                    return React.createElement(MarkerV2, {
                        key: i,
                        position: { lat: location.gpsInfo !== null ? location.gpsInfo.latitude : 0, lng: location.gpsInfo !== null ? location.gpsInfo.longitude : 0 },

                        name: location.assetsInfoName,
                        speed: location.gpsInfo !== null ? location.gpsInfo.speed : 0,
                        angle: location.gpsInfo !== null ? location.gpsInfo.angle : 0,
                        device: location,
                        handleOnClick: _this7.handleOnClick,
                        urlApi: _this7.state.urlApi,
                        accessToken: _this7.state.accessToken,
                        createMarkerHistoricalStopsIndividually: _this7.createMarkerHistoricalStopsIndividually,
                        centerMapWihtOutFollow: _this7.centerMapWihtOutFollow,
                        isOpenDeviceContent: _this7.state.isOpenDeviceContent,
                        centerDevice: _this7.state.centerDevice.assetsIOTImei,
                        setLatLng: _this7.setLatLng,
                        getTaskOrdersLayerFunc: _this7.getTaskOrdersLayerFunc,
                        groupsTasksServicesList: _this7.state.groupsTasksServices,
                        layerDistributionFunc: _this7.layerDistributionFunc,
                        layerDeviceFunc: _this7.layerDeviceFunc,
                        layerDevice: _this7.state.layerDevice,
                        centerMap: _this7.centerMap,
                        groupsDevicesList: _this7.state.groupsDevices,
                        realTimeDevices: _this7.state.markersV,
                        closePopUpDeviceInfo: _this7.closePopUpDeviceInfo,
                        actualMap: _this7.actualMap,
                        actualZoom: _this7.state.actualZoom,
                        transformDateAndCompare: _this7.transformDateAndCompare,
                        tag: location.tag,
                        isVehicleGrouped: _this7.state.isVehicleGrouped
                    });
                }),
                this.state.groupsTasksServices.length > 0 && React.createElement(
                    MarkerClusterer,
                    {
                        options: { imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m" },
                        onClusteringEnd: this.handleClusteringEnd

                    },
                    function (clusterer) {
                        return _this7.state.groupsTasksServices.map(function (item) {
                            return item.destinationList !== null && item.destinationList.map(function (location, i) {
                                return React.createElement(MarkerService, {
                                    key: i,
                                    position: { lat: parseFloat(location.latitud), lng: parseFloat(location.longitud) },
                                    clusterer: clusterer,
                                    name: location.destinatario,
                                    content: location
                                });
                            });
                        });
                    }
                ),
                this.state.jsonPoisInfo.length > 0 ? this.state.jsonPoisInfo.length < 60 ? React.createElement(
                    MarkerClusterer,
                    {
                        options: { imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m" },
                        onClusteringEnd: this.handleClusteringEnd1.bind(this),
                        maxZoom: 10
                    },
                    function (clusterer) {
                        return _this7.state.groupsPois.map(function (item) {
                            return item.poisInfo !== null && item.poisInfo !== undefined && item.poisInfo.length < 60 && (item.isChecked || item.poisInfo.some(function (poi) {
                                return poi.isChecked;
                            })) && // Agregar esta condición
                            item.poisInfo.map(function (location, i) {
                                return location.isChecked && React.createElement(MarkersPois, {
                                    key: location.idTipo + i,
                                    position: { lat: parseFloat(location.latitud), lng: parseFloat(location.longitud) },
                                    content: location,
                                    clusterer: clusterer,
                                    icon: item.icono,
                                    showCircle: _this7.showCircle,
                                    showPopUpPoi: _this7.state.showPopUpPoi,
                                    poiInfo: location
                                });
                            });
                        });
                    }
                ) : React.createElement(
                    MarkerClusterer,
                    {
                        options: { imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m" },
                        onClusteringEnd: this.handleClusteringEnd
                    },
                    function (clusterer) {
                        return _this7.state.groupsPois.map(function (item) {
                            return item.poisInfo !== null && item.poisInfo !== undefined && (item.isChecked || item.poisInfo.some(function (poi) {
                                return poi.isChecked;
                            })) && item.poisInfo.map(function (location, i) {
                                return location.isChecked && React.createElement(MarkersPois, {
                                    key: location.idTipo + i,
                                    position: { lat: parseFloat(location.latitud), lng: parseFloat(location.longitud) },
                                    content: location,
                                    clusterer: clusterer,
                                    icon: item.icono,
                                    showCircle: _this7.showCircle,
                                    showPopUpPoi: _this7.state.showPopUpPoi,
                                    poiInfo: location
                                });
                            });
                        });
                    }
                ) : null,
                this.state.isTrafficLayerShown && React.createElement(TrafficLayer, null),
                this.state.historicalStopIndividuallyMarker !== "" ? React.createElement(Marker, {
                    position: {
                        lat: this.state.historicalStopIndividuallyMarker.latitude,
                        lng: this.state.historicalStopIndividuallyMarker.longitude
                    }
                }) : null,
                this.state.showCircleArea ? React.createElement(Circle, {
                    center: {
                        lat: this.state.centerCircle.latitud,
                        lng: this.state.centerCircle.longitud
                    },
                    options: this.state.optionsCircle
                }) : null,
                this.state.popUpInfoDevice ? React.createElement(
                    'div',
                    { className: 'map-content-collapsible' },
                    React.createElement(
                        PopUpDeviceInfo,
                        {
                            device: this.state.device,
                            address: this.state.addressDevice,
                            historicalInfoDevice: this.state.historicalInfoDevice,
                            centerMapWihtOutFollow: this.centerMapWihtOutFollow,
                            permisionHistory: this.state.permisionHistory,
                            centerMap: this.centerMap,
                            setLatLng: this.setLatLng,
                            createMarkerHistoricalStopsIndividually: this.createMarkerHistoricalStopsIndividually,
                            closePopUpDeviceInfo: this.closePopUpDeviceInfo,
                            accessToken: this.state.accessToken,
                            urlApi: this.state.urlApi,
                            isHistoricalInfoDeviceOpen: this.isHistoricalInfoDeviceOpen,
                            HistoricalInfoDeviceOpen: this.HistoricalInfoDeviceOpen,
                            closePopUpDeviceInfoWithCloseIcon: this.closePopUpDeviceInfoWithCloseIcon,
                            transformDateAndCompare: this.transformDateAndCompare,
                            centerDevice: this.state.centerDevice,
                            isOpenDeviceContent: this.state.isOpenDeviceContent,
                            origin: this.props.origin

                        },
                        React.createElement('span', { onClick: this.closePopUpDeviceInfoWithCloseIcon.bind(this), style: { zIndex: "1", textAlign: "center", position: "absolute", right: "27px", top: "1px", color: "#575757", cursor: "pointer", width: "30px", height: "30px" }, className: 'icon-close_red' })
                    )
                ) : null,
                this.state.showCircleArea ? React.createElement(
                    InfoWindow,
                    {
                        position: {
                            lat: this.state.centerCircle.latitud,
                            lng: this.state.centerCircle.longitud
                        },
                        onCloseClick: this.showCircle.bind(this, this.state.centerCircle)
                    },
                    React.createElement(
                        'div',
                        null,
                        this.state.centerCircle.cliente
                    )
                ) : null,
                this.state.objWhenClickOnMap.visible ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(Marker
                    // onLoad={onLoad}
                    , { visible: this.state.objWhenClickOnMap.markerVisible,
                        icon: markerIcon,
                        position: { lat: parseFloat(this.state.objWhenClickOnMap.lat), lng: parseFloat(this.state.objWhenClickOnMap.lng) }
                    }),
                    React.createElement(
                        Card,
                        { className: "classes.root", style: { paddingBottom: "0px", fontSize: "12px", position: "absolute", left: "calc(50% - 150px)", bottom: "2%", maxWidth: "300px", width: "300px" } },
                        React.createElement(
                            CardContent,
                            { style: { width: "280px" } },
                            React.createElement(
                                'p',
                                { style: { fontSize: "12px" }, onClick: this.handleOnClickClosePopUpDirection.bind(this), className: 'buttonClosePopUp', styles: { position: "absolute", right: "10px", top: "7px" } },
                                React.createElement(ClearOutlinedIcon, { fontSize: 'inherit' })
                            ),
                            !this.state.objWhenClickOnMap.markerVisible ? React.createElement(
                                Grid,
                                {
                                    container: true,
                                    spacing: 2,
                                    direction: 'row',
                                    justify: 'center',
                                    alignItems: 'center',
                                    style: { width: "calc(100% + 16px) !important" }
                                },
                                React.createElement(
                                    Grid,
                                    { item: true, xs: 6 },
                                    React.createElement(
                                        Typography,
                                        { variant: 'body2', style: { fontSize: "12px" }, color: 'textSecondary' },
                                        'Tiempo estimado'
                                    )
                                ),
                                React.createElement(
                                    Grid,
                                    { style: { textAlign: "right" }, item: true, xs: 6 },
                                    React.createElement(
                                        Typography,
                                        { variant: 'body2', style: { fontSize: "12px" }, color: 'textSecondary' },
                                        this.state.directionObjRouteToView.duration
                                    )
                                ),
                                React.createElement(
                                    Grid,
                                    { item: true, xs: 6 },
                                    React.createElement(
                                        Typography,
                                        { variant: 'body2', style: { fontSize: "12px" }, color: 'textSecondary' },
                                        'La ruta m\xE1s r\xE1pida'
                                    )
                                ),
                                React.createElement(
                                    Grid,
                                    { style: { textAlign: "right" }, item: true, xs: 6 },
                                    React.createElement(
                                        Typography,
                                        { variant: 'body2', style: { fontSize: "12px" }, color: 'textSecondary' },
                                        this.state.directionObjRouteToView.distance
                                    )
                                )
                            ) : React.createElement(
                                React.Fragment,
                                null,
                                React.createElement(
                                    'p',
                                    { styles: { fontSize: "12px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", margin: "0", marginBottom: "10px" } },
                                    this.state.objWhenClickOnMap.address
                                ),
                                React.createElement(
                                    'p',
                                    { styles: { fontSize: "12px" }, onClick: this.handleOnClickMap.bind(this), className: 'buttonClosePopUp', style: { position: "absolute", right: "10px", top: "7px" } },
                                    React.createElement(ClearOutlinedIcon, { fontSize: 'inherit' })
                                ),
                                React.createElement(
                                    Typography,
                                    { variant: 'body2', style: { fontSize: "12px" }, color: 'textSecondary' },
                                    this.state.objWhenClickOnMap.latView + ", " + this.state.objWhenClickOnMap.lngView,
                                    React.createElement('br', null)
                                )
                            )
                        ),
                        !this.state.objWhenClickOnMap.markerVisible ? React.createElement(
                            CardActions,
                            null,
                            React.createElement(
                                'div',
                                null,
                                React.createElement(
                                    Tooltip,
                                    {
                                        PopperProps: {
                                            disablePortal: true
                                        }
                                        // onClose={handleTooltipClose}
                                        , open: this.state.isOpenTooltip,
                                        disableFocusListener: true,
                                        disableHoverListener: true,
                                        disableTouchListener: false,
                                        title: t("map.popUpInfoWithTooltip.textTooltip"),
                                        placement: 'right',
                                        arrow: true
                                    },
                                    React.createElement(
                                        Button,
                                        { onClick: this.copyToClipboardAndCreateUrlDirections.bind(this) },
                                        React.createElement(FileCopyOutlinedIcon, { fontSize: 'inherit' })
                                    )
                                )
                            )
                        ) : React.createElement(
                            CardActions,
                            null,
                            React.createElement(
                                'div',
                                null,
                                React.createElement(
                                    Tooltip,
                                    {
                                        PopperProps: {
                                            disablePortal: true
                                        }
                                        // onClose={handleTooltipClose}
                                        , open: this.state.isOpenTooltip,
                                        disableFocusListener: true,
                                        disableHoverListener: true,
                                        disableTouchListener: false,
                                        title: t("map.popUpInfoWithTooltip.textTooltip"),
                                        placement: 'right',
                                        arrow: true
                                    },
                                    React.createElement(
                                        Button,
                                        { onClick: this.copyToClipboardAndCreateUrl.bind(this), style: { justifyContent: "unset", paddingTop: "0px", marginLeft: "3px" }, size: 'small' },
                                        React.createElement(FileCopyOutlinedIcon, { fontSize: 'inherit' })
                                    )
                                )
                            ),
                            React.createElement(
                                Button,
                                { onClick: this.handleOnClickStartHowToGet.bind(this), style: { marginLeft: "175px", textTransform: "unset" } },
                                React.createElement(DirectionsOutlinedIcon, null)
                            )
                        )
                    )
                ) : null,
                this.state.optionsRoute.destination !== "" && this.state.optionsRoute.origin !== "" && React.createElement(DirectionsService
                // required
                , { options: { // eslint-disable-line react-perf/jsx-no-new-object-as-prop
                        destination: this.state.optionsRoute.destination,
                        origin: this.state.optionsRoute.origin,
                        travelMode: "DRIVING"

                    }
                    // required
                    , callback: this.directionsCallback.bind(this)
                    // // optional
                    , onLoad: function onLoad(directionsService) {
                        _this7.setState({
                            directionService: directionsService
                        });
                        // console.log('DirectionsService onLoad directionsService: ', directionsService)
                    }
                    // // optional
                    // onUnmount={directionsService => {
                    //     console.log('DirectionsService onUnmount directionsService: ', directionsService)
                    // }}
                }),
                this.state.response !== null && React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(DirectionsRenderer

                    // panel={document.getElementById('panel')}
                    // required
                    , { options: { // eslint-disable-line react-perf/jsx-no-new-object-as-prop
                            directions: this.state.response === "" ? this.state.directionsRenderer.request : this.state.response,
                            draggable: true,
                            preserveViewport: true
                        },
                        onDirectionsChanged: this.handleOnChangeDirection.bind(this)

                        // onDirectionsChanged={async () => {

                        //     if (this.state.directionsRenderer.directions !== undefined) {
                        //         if (this.isEmpty(this.state.directionsRenderer.directions.request.destination) === false) {
                        //             console.log("onDirectionsChanged if")
                        //             let directionsChanged = this.state.directionsRenderer.getDirections();
                        //             console.log(directionsChanged);
                        //             let destination = await this.getAddress(this.state.directionsRenderer.directions.request.destination.lat(), this.state.directionsRenderer.directions.request.destination.lng());
                        //             this.setState({
                        //                 optionsRoute: {
                        //                     destination: destination,
                        //                     origin: this.state.optionsRoute.origin,
                        //                     travelMode: "DRIVING",
                        //                 },
                        //                 directionsRenderer: this.state.directionsRenderer,
                        //                 response: null,
                        //                 center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
                        //                 options: { ...this.state.options, zoom: this.state.actualMap.zoom },
                        //             });
                        //         } else if(this.isEmpty(this.state.directionsRenderer.directions.request.origin) === false) {
                        //             console.log("onDirectionsChanged else")
                        //             let origin = await this.getAddress(this.state.directionsRenderer.directions.request.origin.lat(), this.state.directionsRenderer.directions.request.origin.lng());

                        //             this.setState({
                        //                 optionsRoute: {
                        //                     ...this.state.optionsRoute,
                        //                     origin: origin,
                        //                 },
                        //                 directionsRenderer: this.state.directionsRenderer,
                        //                 response: null,
                        //                 center: { lat: this.state.actualMap.center.lat(), lng: this.state.actualMap.center.lng() },
                        //                 options: { ...this.state.options, zoom: this.state.actualMap.zoom },
                        //             });
                        //         }
                        //     }

                        // }}
                        // optional
                        , onLoad: function onLoad(directionsRenderer) {

                            _this7.setState({
                                directionsRenderer: directionsRenderer,
                                directionObjRouteToView: {
                                    duration: directionsRenderer.directions.routes[0].legs[0].duration.text,
                                    distance: directionsRenderer.directions.routes[0].legs[0].distance.text
                                },
                                center: { lat: _this7.state.actualMap.center.lat(), lng: _this7.state.actualMap.center.lng() },
                                options: Object.assign({}, _this7.state.options, { zoom: _this7.state.actualMap.zoom })
                            });
                            // , () => {
                            //     // directionsRenderer.addListener("directions_changed", this.handleOnChangeDirection());
                            //     // () => {
                            //     //     // this.handleOnChangeDirection();
                            //     //     // directionsRenderer.setDirections(directionsRenderer.getDirections());
                            //     //     // console.log()
                            //     //     // this.computeTotalDistance(directionsRenderer.getDirections());
                            //     //     setTimeout(() => {
                            //     //         this.setState({
                            //     //             directionsRenderer: this.state.directionsRenderer
                            //     //         })
                            //     //     }, 1000);

                            //     // });
                            // });
                        }
                        // optional
                        // onUnmount={directionsRenderer => {
                        //     // console.log('DirectionsRenderer onUnmount directionsRenderer: ', directionsRenderer)
                        // }}

                    })
                ),
                '(',
                React.createElement(Marker, {
                    visible: this.state.markerPositionToDirectionRoute.visible
                    // onLoad={onLoad}
                    , position: { lat: this.state.markerPositionToDirectionRoute.lat, lng: this.state.markerPositionToDirectionRoute.lng }
                }),
                ')'
            );
        }
    }]);

    return Map;
}(Component);

// export default withTranslation(withStyles(styles, { withTheme: true })(Map));


export default withTranslation()(Map);
// export default Map;